export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  spribetab: {
    mines: {
      href: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      providerName: "Spribe",
      name: "Mines",
      homeUrl: "",
      cover: { src: "/images/spribe/Mines.webp", alt: "mines" },
    },
    goal: {
      href: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      name: "Goal",
      homeUrl: "",
      providerName: "Spribe",
      cover: { src: "/images/spribe/Goal-new.webp", alt: "goal" },
    },
    dice: {
      href: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      name: "Dice",
      provider: "dice",
      providerName: "Spribe",
      homeUrl: "",
      cover: { src: "/images/spribe/Dice-new.webp", alt: "dice" },
    },
    aviator: {
      href: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      providerName: "Spribe",
      name: "Aviator",
      provider: "aviator",
      homeUrl: "",
      cover: { src: "/images/spribe/Aviator-new.webp", alt: "aviator" },
    },
    plinko: {
      href: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      providerName: "Spribe",
      name: "Plinko",
      provider: "plinko",
      homeUrl: "",
      cover: { src: "/images/spribe/Plinko-new.webp", alt: "plinko" },
    },
    miniroulette: {
      href: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      name: "Mini Roulette",
      casino: "spribe",
      provider: "mini-roulette",
      providerName: "Spribe",
      homeUrl: "",
      cover: {
        src: "/images/spribe/MiniRoulette-new.webp",
        alt: "mini roulette",
      },
    },
    hilo: {
      href: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      name: "HiLo",
      providerName: "spribe",
      homeUrl: "",
      cover: { src: "/images/spribe/Hilo-new.webp", alt: "hilo" },
    },
    keno: {
      href: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      providerName: "spribe",
      name: "Keno",
      provider: "keno",
      homeUrl: "",
      cover: { src: "/images/spribe/Keno-new.webp", alt: "hilo" },
    },
    hotline: {
      href: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      providerName: "spribe",
      name: "Hotline",
      provider: "hotline",
      homeUrl: "",
      cover: { src: "/images/spribe/hotline.webp", alt: "hilo" },
    },
    Balloon: {
      href: "/casino/spribe-balloon",
      code: "hotline",
      casino: "spribe",
      providerName: "spribe",
      name: "Balloon",
      provider: "hotline",
      homeUrl: "",
      cover: { src: "/images/spribe/Balloon.jpg", alt: "hilo" },
    },
    // Poker: {
    //   href: "/casino/spribe-poker",
    //   code: "hotline",
    //   casino: "spribe",
    //   providerName: "spribe",
    //   name: "Poker",
    //   provider: "hotline",
    //   homeUrl: "",
    //   cover: { src: "/images/spribe/Poker.jpg", alt: "hilo" },
    // },
  },
  ezuginetenttab: {
    asgardianstones: {
      href: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "/images/slots/AsgardianStones-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      href: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "/images/slots/SecretsofAtlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      href: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "/images/slots/SteamTower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "/images/slots/DivineFortuneMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      href: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "/images/slots/FruitShopMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "/images/slots/GorillaKingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      href: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "/images/slots/AlohaChristmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      href: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "/images/slots/AlohaClusterPays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      href: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "/images/slots/WildWildWestTheGreatTrainHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "/images/slots/twinspinmegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      href: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "/images/slots/TurnYourFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      href: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "/images/slots/pyramidquestforimmortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
    PiggyRiches: {
      href: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      imgUrl: "/images/slots/Piggy-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches",
      providerName: "slots",
    },
    DarkKing: {
      href: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "/images/slots/darkkingforbiddenriches-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    JingleSpin: {
      href: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "/images/slots/jinglespin-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      href: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "/images/slots/Jackhammer-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
    DeadorAlive: {
      href: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      imgUrl: "/images/slots/Dead-or-Alive.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive",
      providerName: "slots",
    },
    DeadorAlive2: {
      href: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      imgUrl: "/images/slots/Dead-or-Alive-2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive 2",
      providerName: "slots",
    },
    JackandtheBeanstalk: {
      href: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      imgUrl: "/images/slots/Jack-and-the-Beanstalk.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack and the Beanstalk",
      providerName: "slots",
    },
    Elements: {
      href: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      imgUrl: "/images/slots/Elements-The-Awakening.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Elements: The Awakening",
      providerName: "slots",
    },
    FinnandtheSwirlySpin: {
      href: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      imgUrl: "/images/slots/Finn-and-the-Swirly-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Finn and the Swirly Spin",
      providerName: "slots",
    },
    FruitShop: {
      href: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      imgUrl: "/images/slots/Fruit-Shop.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop",
      providerName: "slots",
    },
    // DeadorAlive2FeatureBuy: {
    //   href: "/casino/ezgne-dead-or-alive-2-feature-buy",
    //   code: "1100100",
    //   casino: "ezugi",
    //   imgUrl: "/images/slots/DeadOrAlive2FeatureBuy.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Dead or Alive 2 Feature Buy",
    //   providerName: "slots",
    // },
  },

  auragamingtab: {
    Blastoff: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blastoff",
      name: "Blastoff",
      providerName: "aura",
      imgUrl: "/images/aura/Blastoff.webp",
      href: "/casino/aura-blastoff",
    },
    FortuneWheel: {
      code: "70001",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Wheel",
      name: "Fortune Wheel",
      providerName: "aura",
      imgUrl: "/images/aura/FortuneWheel.webp",
      href: "/casino/aura-fortune-wheel",
    },
    CoinToss: {
      code: "70003",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Toss",
      name: "Coin Toss",
      providerName: "aura",
      imgUrl: "/images/aura/CoinToss.webp",
      href: "/casino/aura-coin-toss",
    },
    Limbo: {
      code: "70004",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "aura",
      imgUrl: "/images/aura/Limbo.webp",
      href: "/casino/aura-limbo",
    },
    SlotGame: {
      code: "70005",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Slot Game",
      name: "Slot Game",
      providerName: "aura",
      imgUrl: "/images/aura/SlotGame.webp",
      href: "/casino/aura-slot-game",
    },
    RockPaperScissors: {
      code: "70006",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "aura",
      imgUrl: "/images/aura/RockPaperScissors.webp",
      href: "/casino/aura-rock-paper-scissors",
    },
    Cricket: {
      code: "70008",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket",
      name: "Cricket",
      providerName: "aura",
      imgUrl: "/images/aura/Cricket.webp",
      href: "/casino/aura-cricket",
    },
    ClassicDice: {
      code: "70009",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Dice",
      name: "Classic Dice",
      providerName: "aura",
      imgUrl: "/images/aura/ClassicDice.webp",
      href: "/casino/aura-classic-dice",
    },
    Mines: {
      code: "70011",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "aura",
      imgUrl: "/images/aura/Mines.webp",
      href: "/casino/aura-mines",
    },
    Aviator: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aviator",
      name: "Aviator",
      providerName: "aura",
      imgUrl: "/images/aura/Aviator.webp",
      href: "/casino/aura-aviator",
    },
    "7up&Down(Virtual)": {
      code: "98793",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7 up & Down (Virtual)",
      name: "7 up & Down (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/7up&Down(Virtual).webp",
      href: "/casino/aura-7-up-&-down-virtual",
    },
    "DragonTiger(Virtual)": {
      code: "98794",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger (Virtual)",
      name: "Dragon Tiger (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/DragonTiger(Virtual).webp",
      href: "/casino/aura-dragon-tiger-virtual",
    },
    "TeenpattiT20(Virtual)": {
      code: "56769",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti T20 (Virtual)",
      name: "Teenpatti T20 (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiT20(Virtual).webp",
      href: "/casino/aura-teenpatti-t20-virtual",
    },
    "HiLow(Virtual)": {
      code: "56969",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Low (Virtual)",
      name: "Hi Low (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/HiLow(Virtual).webp",
      href: "/casino/aura-hi-low-virtual",
    },
    "AmarAkbarAnthony(Virtual)": {
      code: "98795",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Amar Akbar Anthony (Virtual)",
      name: "Amar Akbar Anthony (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/AmarAkbarAnthony(Virtual).webp",
      href: "/casino/aura-amar-akbar-anthony-virtual",
    },
    "Roulette(Virtual)": {
      code: "98792",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Roulette (Virtual)",
      name: "Roulette (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Roulette(Virtual).webp",
      href: "/casino/aura-roulette-virtual",
    },
    "AndarBahar(Virtual)": {
      code: "87565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar (Virtual)",
      name: "Andar Bahar (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/AndarBahar(Virtual).webp",
      href: "/casino/aura-andar-bahar-virtual",
    },
    "32cardscasino(Virtual)": {
      code: "56966",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "32 cards casino (Virtual)",
      name: "32 cards casino (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/32cardscasino(Virtual).webp",
      href: "/casino/aura-32-cards-casino-virtual",
    },
    "Matka(Virtual)": {
      code: "92036",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka (Virtual)",
      name: "Matka (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Matka(Virtual).webp",
      href: "/casino/aura-matka-virtual",
    },
    "TeenpattiOne-Day(Virtual)": {
      code: "56766",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti One-Day (Virtual)",
      name: "Teenpatti One-Day (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiOneDay(Virtual).webp",
      href: "/casino/aura-teenpatti-one-day-virtual",
    },
    "Poker(Virtual)": {
      code: "67563",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker  (Virtual)",
      name: "Poker  (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Poker(Virtual).webp",
      href: "/casino/aura-poker-virtual",
    },
    "Sixplayerpoker(Virtual)": {
      code: "67566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker (Virtual)",
      name: "Six player poker (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Sixplayerpoker(Virtual).webp",
      href: "/casino/aura-six-player-poker-virtual",
    },
    "Race20-20(Virtual)": {
      code: "90101",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20 (Virtual)",
      name: "Race 20-20 (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Race20-20(Virtual).webp",
      href: "/casino/aura-Race-20-20-virtual",
    },
    "MuflisTeenpatti(virtual)": {
      code: "67601",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Muflis Teenpatti (virtual)",
      name: "Muflis Teenpatti (virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/MuflisTeenpatti(virtual).webp",
      href: "/casino/aura-muflis-teenpatti-virtual",
    },
    "Poker20-20(Virtual)": {
      code: "67568",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker 20-20 (Virtual)",
      name: "Poker 20-20 (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Poker20-20(Virtual).webp",
      href: "/casino/aura-poker-20-20-virtual",
    },
    "Trio(virtual)": {
      code: "67611",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio (virtual)",
      name: "Trio (virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Trio(virtual).webp",
      href: "/casino/aura-trio-virtual",
    },
    "CasinoMeter(Virtual)": {
      code: "67576",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter (Virtual)",
      name: "Casino Meter (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/CasinoMeter(Virtual).webp",
      href: "/casino/aura-casino-meter-virtual",
    },
    "TeenpattiTest(virtual)": {
      code: "67631",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Test (virtual)",
      name: "Teenpatti Test (virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiTest(virtual).webp",
      href: "/casino/aura-teenpatti-test-virtual",
    },
    "TeenpattiOpen(virtual)": {
      code: "67641",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open (virtual)",
      name: "Teenpatti Open (virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiOpen(virtual).webp",
      href: "/casino/aura-teenpatti-open-virtual",
    },
    "CasinoWar(Virtual)": {
      code: "67581",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino War (Virtual)",
      name: "Casino War (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/CasinoWar(Virtual).webp",
      href: "/casino/aura-casino-war-virtual",
    },
    "Baccarat(Virtual)": {
      code: "92039",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat (Virtual)",
      name: "Baccarat (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/Baccarat(Virtual).webp",
      href: "/casino/aura-baccarat-virtual",
    },
    "BollywoodCasino(Virtual)": {
      code: "67571",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bollywood Casino (Virtual)",
      name: "Bollywood Casino (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/BollywoodCasino(Virtual).webp",
      href: "/casino/aura-bollywood-casino-virtual",
    },
    "QueenRace(Virtual)": {
      code: "67621",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Queen Race (Virtual)",
      name: "Queen Race (Virtual)",
      providerName: "aura",
      imgUrl: "/images/aura/QueenRace.webp",
      href: "/casino/aura-queen-race-virtual",
    },
    Poker: {
      code: "67564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker",
      name: "Poker",
      providerName: "aura",
      imgUrl: "/images/aura/Poker.webp",
      href: "/casino/aura-poker",
    },
    SuperOver: {
      code: "67720",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Over",
      name: "Super Over",
      providerName: "aura",
      imgUrl: "/images/aura/SuperOver.webp",
      href: "/casino/aura-sper-over",
    },
    Matka: {
      code: "92037",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Matka",
      name: "Matka",
      providerName: "aura",
      imgUrl: "/images/aura/Matka(Virtual).webp",
      href: "/casino/aura-matka",
    },
    Baccarat: {
      code: "92038",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "aura",
      imgUrl: "/images/aura/Baccarat.webp",
      href: "/casino/aura-baccarat",
    },
    Trio: {
      code: "67610",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trio",
      name: "Trio",
      providerName: "aura",
      imgUrl: "/images/aura/Trio.webp",
      href: "/casino/aura-trio",
    },
    "3CardsJudgement": {
      code: "67670",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
      providerName: "aura",
      imgUrl: "/images/aura/3CardsJudgement.webp",
      href: "/casino/aura-3-cards-judgement",
    },
    "Race20-20": {
      code: "90100",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race 20-20",
      name: "Race 20-20",
      providerName: "aura",
      imgUrl: "/images/aura/Race20-20.webp",
      href: "/casino/aura-race-20-20",
    },
    "29CardBaccarat": {
      code: "67690",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "aura",
      imgUrl: "/images/aura/29CardBaccarat.webp",
      href: "/casino/aura-29-card-baccarat",
    },
    TeenpattiOpen: {
      code: "67640",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Open",
      name: "Teenpatti Open",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiOpen.webp",
      href: "/casino/aura-teenpatti-open",
    },
    Raceto17: {
      code: "67710",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Race to 17",
      name: "Race to 17",
      providerName: "aura",
      imgUrl: "/images/aura/Raceto17.webp",
      href: "/casino/aura-race-to-17",
    },
    Sixplayerpoker: {
      code: "67565",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Six player poker",
      name: "Six player poker",
      providerName: "aura",
      imgUrl: "/images/aura/Sixplayerpoker.webp",
      href: "/casino/aura-six-player-poker",
    },
    CasinoMeter: {
      code: "67575",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino Meter",
      name: "Casino Meter",
      providerName: "aura",
      imgUrl: "/images/aura/CasinoMeter.webp",
      href: "/casino/aura-casino-meter",
    },
    TheTrap: {
      code: "67680",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Trap",
      name: "The Trap",
      providerName: "aura",
      imgUrl: "/images/aura/TheTrap.webp",
      href: "/casino/aura-the-trap",
    },
    DreamCatcher: {
      code: "98567",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dream Catcher",
      name: "Dream Catcher",
      providerName: "aura",
      imgUrl: "/images/aura/DreamCatcher.webp",
      href: "/casino/aura-dream-catcher",
    },
    TeenpattiT20: {
      code: "56768",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti T20",
      name: "Teenpatti T20",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiT20Old.jpg",
      href: "/casino/aura-teenpatti-t20",
    },
    DragonTiger: {
      code: "98790",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "aura",
      imgUrl: "/images/aura/DragonTiger.webp",
      href: "/casino/aura-dragon-tiger",
    },
    UpDown7: {
      code: "98789",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "7 Up Down",
      name: "7 Up Down",
      providerName: "aura",
      imgUrl: "/images/aura/7UpDown.webp",
      href: "/casino/aura-7-up-down",
    },
    HiLow: {
      code: "56968\n",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Low",
      name: "Hi Low",
      providerName: "aura",
      imgUrl: "/images/aura/HiLow.webp",
      href: "/casino/aura-hi-low",
    },
    Card2Teenpatti: {
      code: "67660",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "2 Card Teenpatti",
      name: "2 Card Teenpatti",
      providerName: "aura",
      imgUrl: "/images/aura/2CardsTeenpatti.webp",
      href: "/casino/aura-2-card-teenpatti",
    },
    CasinoWar: {
      code: "67580",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Casino War",
      name: "Casino War",
      providerName: "aura",
      imgUrl: "/images/aura/CasinoWar.webp",
      href: "/casino/aura-casino-war",
    },
    MuflisTeenpatti: {
      code: "67600",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Muflis Teenpatti",
      name: "Muflis Teenpatti",
      providerName: "aura",
      imgUrl: "/images/aura/MuflisTeenpatti.webp",
      href: "/casino/aura-muflis-teenpatti",
    },
    AndarBahar: {
      code: "87564",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "aura",
      imgUrl: "/images/aura/AndarBahar.webp",
      href: "/casino/aura-andar-bahar",
    },
    QueenRace: {
      code: "67620",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Queen Race",
      name: "Queen Race",
      providerName: "aura",
      imgUrl: "/images/aura/QueenRace.webp",
      href: "/casino/aura-queen-race",
    },
    Poker2020: {
      code: "67567",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poker 20-20",
      name: "Poker 20-20",
      providerName: "aura",
      imgUrl: "/images/aura/Poker20-20.webp",
      href: "/casino/aura-poker-20-20",
    },
    BollywoodCasino: {
      code: "67570",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bollywood Casino",
      name: "Bollywood Casino",
      providerName: "aura",
      imgUrl: "/images/aura/BollywoodCasino.webp",
      href: "/casino/aura-bollywood-casino",
    },
    Teenpatti1Day: {
      code: "56767",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti 1 Day",
      name: "Teenpatti 1 Day",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiOneDay.webp",
      href: "/casino/aura-teenpatti-1-Day",
    },
    Roulette: {
      code: "98788",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Roulette",
      name: "Roulette",
      providerName: "aura",
      imgUrl: "/images/aura/Roulette.webp",
      href: "/casino/aura-roulette",
    },
    AmarAkbarAnthony: {
      code: "98791",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Amar Akbar Anthony",
      name: "Amar Akbar Anthony",
      providerName: "aura",
      imgUrl: "/images/aura/AmarAkbarAnthony.webp",
      href: "/casino/aura-amar-akbar-anthony",
    },
    TeenpattiTest: {
      code: "67630",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Teenpatti Test",
      name: "Teenpatti Test",
      providerName: "aura",
      imgUrl: "/images/aura/TeenpattiTest.webp",
      href: "/casino/aura-teenpatti-test",
    },
    Sicbo: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sicbo",
      name: "Sicbo",
      providerName: "aura",
      imgUrl: "/images/aura/Sicbo.webp",
      href: "/casino/aura-sicbo",
    },
  },

  qtechpokertab: {
    DXocDia: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "D Xoc Dia",
      name: "D Xoc Dia",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/SAG-dxocdia.png",
      href: "/casino/qt-d-xoc-dia",
    },
    DSicBo: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "D Sic Bo",
      name: "D Sic Bo",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/SAG-dsicbo.png",
      href: "/casino/qt-sag-dsicbo",
    },
    // GravitySicBo: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Gravity Sic Bo",
    //   name: "Gravity Sic Bo",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Gravity-SicBo.jpg",
    //   href: "/casino/qt-gravity-sic-bo",
    // },
    // TeenPattiRapid: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Teen Patti Rapid",
    //   name: "Teen Patti Rapid",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TeenPattiRapid.webp",
    //   href: "/casino/qt-teen-patti-rapid",
    // },
    // TriCardPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Tri Card Poker",
    //   name: "Tri Card Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TriCardPoker.webp",
    //   href: "/casino/qt-tri-card-poker",
    // },
    // TeenPattiPro: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Teen Patti Pro",
    //   name: "Teen Patti Pro",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TeenPattiPro.webp",
    //   href: "/casino/qt-teen-patti-pro",
    // },
    // TurboPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Turbo Poker",
    //   name: "Turbo Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TurboPoker.webp",
    //   href: "/casino/qt-turbo-poker",
    // },
    // MagicPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Magic Poker",
    //   name: "Magic Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/MagicPoker.webp",
    //   href: "/casino/qt-magic-poker",
    // },
    // ThreeCards: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Three Cards",
    //   name: "Three Cards",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/ThreeCards.webp",
    //   href: "/casino/qt-three-cards",
    // },
    // JokerPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Joker Poker",
    //   name: "Joker Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/JokerPoker.webp",
    //   href: "/casino/qt-joker-poker",
    // },
    // CaribbeanBeachPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Caribbean Beach Poker",
    //   name: "Caribbean Beach Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/CaribbeanBeachPoker.webp",
    //   href: "/casino/qt-caribbean-beach-poker",
    // },
    // AmericanPokerV: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "American Poker V",
    //   name: "American Poker V",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/AmericanPokerV.webp",
    //   href: "/casino/qt-american-poker-v",
    // },
    // AmericanPokerGold: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "American Poker Gold",
    //   name: "American Poker Gold",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/AmericanPokerGold.webp",
    //   href: "/casino/qt-american-poker-gold",
    // },
    // SanGong: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "San Gong",
    //   name: "San Gong",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/SanGong.webp",
    //   href: "/casino/qt-san-gong",
    // },
    // JacksorBetter: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Jacks or Better",
    //   name: "Jacks or Better",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/JacksorBetter.webp",
    //   href: "/casino/qt-jacks-or-better-u7460",
    // },
    // Card3Brag: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "3 Card Brag",
    //   name: "3 Card Brag",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/3CardBrag.webp",
    //   href: "/casino/qt-3-card-brag",
    // },
    // JokerPokerMH: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Joker Poker MH",
    //   name: "Joker Poker MH",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Joker-poker.png",
    //   href: "/casino/qt-joker-poker-mh",
    // },
    // JacksorBetterMH: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Jacks or Better MH",
    //   name: "Jacks or Better MH",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Jacks-or-better.png",
    //   href: "/casino/qt-jacks-or-better-mh",
    // },
    // InBetweenPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "In Between Poker",
    //   name: "In Between Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/InBetweenPoker.webp",
    //   href: "/casino/qt-in-between-poker",
    // },
    // Hand3CasinoHoldem: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "3-Hand Casino Hold'em",
    //   name: "3-Hand Casino Hold'em",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/3-hand-casino-holdem.png",
    //   href: "/casino/qt-3-hand-casino-holdem",
    // },
    // TeenPatti2020: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Teen Patti 20-20",
    //   name: "Teen Patti 20-20",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TeenPatti2020.webp",
    //   href: "/casino/qt-teen-patti-20-20-u1817",
    // },
    // DeucesWild: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Deuces Wild",
    //   name: "Deuces Wild",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Deuces-Wild.png",
    //   href: "/casino/qt-deuces-wild",
    // },
    // RussianPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Russian Poker",
    //   name: "Russian Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/RussianPoker.webp",
    //   href: "/casino/qt-russian-poker",
    // },
    // HoldemPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Hold’em Poker",
    //   name: "Hold’em Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Holdempoker.webp",
    //   href: "/casino/qt-holdem-poker",
    // },
    // HighHandHoldemPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "High Hand Hold'em Poker",
    //   name: "High Hand Hold'em Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/HighHandHoldemPoker.webp",
    //   href: "/casino/qt-high-hand-holdem-poker",
    // },
    // CasinoHoldem: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Casino Hold'em",
    //   name: "Casino Hold'em",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/CasinoHoldem.webp",
    //   href: "/casino/qt-casino-holdem-u3512",
    // },
    // JacksorBetterDoubleUp: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Jacks or Better Double Up",
    //   name: "Jacks or Better Double Up",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/JacksorBetterDoubleUp.webp",
    //   href: "/casino/qt-jacks-or-better-double-up",
    // },
    ThreeCardPoker: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Three Card Poker",
      name: "Three Card Poker",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Three-Card-Poker.png",
      href: "/casino/qt-three-card-poker-u1263",
    },
    SicBo: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Sic-Bo.png",
      href: "/casino/qt-sic-bo-u7157",
    },
    ThreeCardPokerDeluxe: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Three Card Poker Deluxe",
      name: "Three Card Poker Deluxe",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Three-Card-Poker-Deluxe.png",
      href: "/casino/qt-three-card-poker-deluxe",
    },
    CaribbeanStud: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Caribbean Stud",
      name: "Caribbean Stud",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Caribbean-Stud.png",
      href: "/casino/qt-caribbean-stud",
    },
    // CaribbeanStudPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Caribbean Stud Poker",
    //   name: "Caribbean Stud Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/CaribbeanStudPoker.webp",
    //   href: "/casino/qt-caribbean-stud-poker-u7535",
    // },
    // OasisPokerClassic: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Oasis Poker Classic",
    //   name: "Oasis Poker Classic",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/OasisPokerClassic.webp",
    //   href: "/casino/qt-oasis-poker-classic",
    // },
    // TexasHoldemPoker3D: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Texas Hold'em Poker 3D",
    //   name: "Texas Hold'em Poker 3D",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TexasHoldemPoker3D.webp",
    //   href: "/casino/qt-texas-holdem-poker-3d",
    // },
    // TexasHoldemBonus: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Texas Hold 'em Bonus",
    //   name: "Texas Hold 'em Bonus",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TexasHold-emBonus.webp",
    //   href: "/casino/qt-texas-hold-em-bonus",
    // },
    // TeenPatti: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Teen Patti",
    //   name: "Teen Patti",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TeenPatti.webp",
    //   href: "/casino/qt-teen-patti-u3569",
    // },
    // AndarNights: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Andar Nights",
    //   name: "Andar Nights",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/AndarNights.webp",
    //   href: "/casino/qt-andar-nights",
    // },
    // SicBo888: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Sic Bo 888",
    //   name: "Sic Bo 888",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Sic-Bo-888.png",
    //   href: "/casino/qt-sic-bo-888",
    // },
    // FirstPersonFootballStudio: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "First Person Football Studio",
    //   name: "First Person Football Studio",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/FirstPersonFootballStudio.webp",
    //   href: "/casino/qt-first-person-football-studio",
    // },
    // AnimalMadness: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Animal Madness",
    //   name: "Animal Madness",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Animal-madness.png",
    //   href: "/casino/qt-animal-madness",
    // },
    // AceofSpades: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Ace of Spades",
    //   name: "Ace of Spades",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Ace-of-Spades.png",
    //   href: "/casino/qt-ace-of-spades",
    // },
    // X5Magic: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "5x Magic",
    //   name: "5x Magic",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/6x-Magic.png",
    //   href: "/casino/qt-5x-magic",
    // },
    // WildTexas: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Wild Texas",
    //   name: "Wild Texas",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/WildTexas.webp",
    //   href: "/casino/qt-wild-texas",
    // },
    // TreyPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Trey Poker",
    //   name: "Trey Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TreyPoker.webp",
    //   href: "/casino/qt-trey-poker",
    // },
    // TexasHoldem: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Texas Hold`em",
    //   name: "Texas Hold`em",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/TexasHoldem.webp",
    //   href: "/casino/qt-texas-holdem",
    // },
    // OasisPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Oasis Poker",
    //   name: "Oasis Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/OasisPoker.webp",
    //   href: "/casino/qt-oasis-poker",
    // },
    // CaribbeanPoker: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Caribbean Poker",
    //   name: "Caribbean Poker",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/CaribbeanPoker.webp",
    //   href: "/casino/qt-caribbean-poker",
    // },
    // Speedy7: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Speedy 7",
    //   name: "Speedy 7",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechNew/Speedy-7.png",
    //   href: "/casino/qt-speedy-7",
    // },
    BetonPoker: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet on Poker",
      name: "Bet on Poker",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Bet-On-Poker.png",
      href: "/casino/qt-bet-on-poker",
    },
    Poker6: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "6+ Poker",
      name: "6+ Poker",
      providerName: "Qtech",
      imgUrl: "/images/qtechNew/Poker-6.png",
      href: "/casino/qt-6-poker",
    },
    Lucky7: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 7",
      name: "Lucky 7",
      providerName: "Qtech",
      imgUrl: "/images/aura/Lucky.png",
      href: "/casino/qt-lucky-7",
    },
  },

  qtechfunwctab: {
    // ReelNightmare: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Reel Nightmare",
    //   name: "Reel Nightmare",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechWCNew/Reel-Nightmare.png",
    //   href: "/casino/qt-reel-nightmare",
    // },
    "Rise of Ymir": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rise of Ymir",
      name: "Rise of Ymir",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Rise-of-Ymir.png",
      href: "/casino/qt-rise-of-ymir",
    },
    "Fire My Laser": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fire My Laser",
      name: "Fire My Laser",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Fire-my-Laser.png",
      href: "/casino/qt-fire-my-laser",
    },
    "Dragon's Domain": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon's Domain",
      name: "Dragon's Domain",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Dragon’s-Domain.png",
      href: "/casino/qt-dragons-domain",
    },
    // CatrinasCoins: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Catrina’s Coins",
    //   name: "Catrina’s Coins",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechWCNew/Catrins-Coins.png",
    //   href: "/casino/qt-catrinas-coins",
    // },
    // BrooklynBootleggers: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Brooklyn Bootleggers",
    //   name: "Brooklyn Bootleggers",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechWCNew/Brooklyn-Bootleggers.png",
    //   href: "/casino/qt-brooklyn-bootleggers",
    // },
    // BrawlersBarCashCollect: {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Brawlers Bar Cash Collect",
    //   name: "Brawlers Bar Cash Collect",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechWCNew/Brawlers-Bar-Cash-Collect.png",
    //   href: "/casino/qt-brawlers-bar-cash-collect",
    // },
    "xWays Hoarder 2": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "xWays Hoarder 2",
      name: "xWays Hoarder 2",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/xWays Hoarder 2.png",
      href: "/casino/qt-xways-hoarder-2",
    },
    "Blood and Shadow 2": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blood and Shadow 2",
      name: "Blood and Shadow 2",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Blood and Shadow 2.png",
      href: "/casino/qt-blood-and-shadow-2",
    },
    "Blood Diamond": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blood Diamond",
      name: "Blood Diamond",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Blood Diamond.png",
      href: "/casino/qt-blood-diamond",
    },
    "Jolly Bonus Wins": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jolly Bonus Wins",
      name: "Jolly Bonus Wins",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Jolly Bonus Wins.png",
      href: "/casino/qt-jolly-bonus-wins",
    },
    "Donut Division": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Donut Division",
      name: "Donut Division",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Donut-Division.png",
      href: "/casino/qt-hak-donutdivision",
    },
    "Venetian Magic": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Venetian Magic",
      name: "6Venetian Magic",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Venetian-Magie.jpg",
      href: "/casino/qt-venetian-magic",
    },
    "Twin Dice Of Olympus": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Twin Dice Of Olympus",
      name: "Twin Dice Of Olympus",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Twin-Dice-olymplis.jpg",
      href: "/casino/qt-twin-dice-of-olympus",
    },
    "The Candy Slot Deluxe": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Candy Slot Deluxe",
      name: "The Candy Slot Deluxe",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/The-candy-slot-delux.jpg",
      href: "/casino/qt-the-candy-slot-deluxe",
    },
    // "The Candy Crush": {
    //   code: "67722",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "The Candy Crush",
    //   name: "The Candy Crush",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechWCNew/The-candy-Crush.jpg",
    //   href: "/casino/qt-the-candy-crush",
    // },
    "Rocket Chimp Jackpot!": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rocket Chimp Jackpot!",
      name: "Rocket Chimp Jackpot!",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Rocket-Chimp-jackpot.jpg",
      href: "/casino/qt-rocket-chimp-jackpot",
    },
    "Reveal the Kraken": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Reveal the Kraken",
      name: "Reveal the Kraken",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Reveal-the-kraken.jpg",
      href: "/casino/qt-reveal-the-kraken",
    },
    "PinUp Dolls": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PinUp Dolls",
      name: "PinUp Dolls",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Pinup-Dolls.jpg",
      href: "/casino/qt-pinup-dolls",
    },
    "Merry Scary Christmas!": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Merry Scary Christmas!",
      name: "Merry Scary Christmas!",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Mery-scary-christmas.jpg",
      href: "/casino/qt-merry-scary-christmas",
    },
    "Loot The Train!": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Loot The Train!",
      name: "Loot The Train!",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Loot-the-train.jpg",
      href: "/casino/qt-loot-the-train",
    },
    "Lion's Pride": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lion's Pride",
      name: "Lion's Pride",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Lion-Pride.jpg",
      href: "/casino/qt-lions-pride",
    },
    "Hydra's Lair": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hydra's Lair",
      name: "Hydra's Lair",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Hydra-lair.jpg",
      href: "/casino/qt-hydras-lair",
    },
    "Gryphon's Castle": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gryphon's Castle",
      name: "Gryphon's Castle",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Gryphons-castle.jpg",
      href: "/casino/qt-gryphons-castle",
    },
    "Fruit Monaco": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Monaco",
      name: "Fruit Monaco",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Fruit-Monaco.jpg",
      href: "/casino/qt-fruit-monaco",
    },
    "Fruit Macau": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Macau",
      name: "Fruit Macau",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Fruit-macau.jpg",
      href: "/casino/qt-fruit-macau",
    },
    "Fruit Disco: Mega Stacks": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Disco: Mega Stacks",
      name: "Fruit Disco: Mega Stacks",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Fruit-disco-Mega-stacks.jpg",
      href: "/casino/qt-fruit-disco-mega-stacks",
    },
    "Fairytale Coven": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fairytale Coven",
      name: "Fairytale Coven",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Fairy-Tale-Coven.jpg",
      href: "/casino/qt-fairytale-coven",
    },
    "Dragon’s Nest": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon’s Nest",
      name: "Dragon’s Nest",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Dragon-Nest.jpg",
      href: "/casino/qt-dragons-nest",
    },
    "Dice Disco: Mega Stacks": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Disco: Mega Stacks",
      name: "Dice Disco: Mega Stacks",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Dice-Disco-Mega-Stacks.jpg",
      href: "/casino/qt-dice-disco-mega-stacks",
    },
    "Christmas Infinite Gifts": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Christmas Infinite Gifts",
      name: "Christmas Infinite Gifts",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Christmas-infinite-gifts.jpg",
      href: "/casino/qt-christmas-infinite-gifts",
    },
    "CanCan Saloon": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "CanCan Saloon",
      name: "CanCan Saloon",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Saloon.jpg",
      href: "/casino/qt-cancan-saloon",
    },
    "Bastet and Cats": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bastet and Cats",
      name: "Bastet and Cats",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Bastet-and-cats.jpg",
      href: "/casino/qt-bastet-and-cats",
    },
    "Aloha! Tiki Bar": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aloha! Tiki Bar",
      name: "Aloha! Tiki Bar",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Aloha-tiki-bar.jpg",
      href: "/casino/qt-aloha-tiki-bar",
    },
    "Wild Wild Bet": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Wild Bet",
      name: "Wild Wild Bet",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Wild-wild-bet.jpg",
      href: "/casino/qt-wild-wild-bet",
    },
    "Wild Spirit": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Spirit",
      name: "Wild Spirit",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/WIld-Spirit.jpg",
      href: "/casino/qt-wild-spirit-u8211",
    },
    "Octo Attack": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Octo Attack",
      name: "Octo Attack",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Octo-Attack.png",
      href: "/casino/qt-hak-octoattack",
    },
    "3 Porky Banks Extra": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Porky Banks Extra",
      name: "3 Porky Banks Extra",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/3 Porky Banks Christmas Edition.png",
      href: "/casino/qt-ids-3porkybanksholdandwinextra",
    },
    "Sticky Bandits Unchained": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sticky Bandits Unchained",
      name: "Sticky Bandits Unchained",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Sticky-Bandits-Unchained.png",
      href: "/casino/qt-qs-stickybanditsunchained",
    },
    "Temple of Paw": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Temple of Paw",
      name: "Temple of Paw",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Temple of Paw.png",
      href: "/casino/qt-qs-templeofpaw",
    },
    "Epic Fish Adventure": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Epic Fish Adventure",
      name: "Epic Fish Adventure",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Epic Fish Adventure.png",
      href: "/casino/qt-qs-epicfishadventure",
    },
    "San Quentin 2: Death Row": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "San Quentin 2: Death Row",
      name: "San Quentin 2: Death Row",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/San Quentin 2 Death Row.png",
      href: "/casino/qt-nlc-sanquentin2deathrow",
    },
    "Scepter of Anubis": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Scepter of Anubis",
      name: "Scepter of Anubis",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Scepter of Anubis.png",
      href: "/casino/qt-qs-scepterofanubis",
    },
    "Marlin Masters": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Marlin Masters",
      name: "Marlin Masters",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Marlin-Masters.png",
      href: "/casino/qt-hak-marlinmasters",
    },
    "Gods of Olympus IV": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gods of Olympus IV",
      name: "Gods of Olympus IV",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Gods of Olympus IV.png",
      href: "/casino/qt-ids-godsofolympus4",
    },
    "Duck Hunters": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Duck Hunters",
      name: "Duck Hunters",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Duck Hunters.png",
      href: "/casino/qt-nlc-duckhunters",
    },
    "Strength of Hercules": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Strength of Hercules",
      name: "Strength of Hercules",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Strength-of-Hercules.png",
      href: "/casino/qt-hak-strengthofhercules",
    },
    "Phoenix DuelReels": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Phoenix DuelReels",
      name: "Phoenix DuelReels",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Phoenix-DuelReels.png",
      href: "/casino/qt-hak-phoenixduelreels",
    },
    "Dorks of the Deep": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dorks of the Deep",
      name: "Dorks of the Deep",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Dorks-of-the-Deep.png",
      href: "/casino/qt-hak-dorksofthedeep",
    },
    "Rad Maxx": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rad Maxx",
      name: "Rad Maxx",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Rad-Maxx.png",
      href: "/casino/qt-hak-radmaxx",
    },
    "Reign of Rome": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Reign of Rome",
      name: "Reign of Rome",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Reign-of-Rome.png",
      href: "/casino/qt-hak-reignofrome",
    },
    "Le Pharaoh": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Le Pharaoh",
      name: "Le Pharaoh",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Le-Pharaoh.png",
      href: "/casino/qt-hak-lepharaoh",
    },
    "Duel at Dawn": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Duel at Dawn",
      name: "Duel at Dawn",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Duel-at-Dawn.png",
      href: "/casino/qt-hak-duelatdawn",
    },
    "Le Viking": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Le Viking",
      name: "Le Viking",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Le-Viking.png",
      href: "/casino/qt-hak-leviking",
    },
    Xterminate: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Xterminate",
      name: "Xterminate",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Xterminate.png",
      href: "/casino/qt-xterminate",
    },
    "Xmas Drop": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Xmas Drop",
      name: "Xmas Drop",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Xmas-Drop.png",
      href: "/casino/qt-xmas-drop",
    },
    Wheel: {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wheel",
      name: "Wheel",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Wheel.png",
      href: "/casino/qt-wheel",
    },
    "Western Wilds Megaways": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Western Wilds Megaways",
      name: "Western Wilds Megaways",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Western-Wilds-Megaways.png",
      href: "/casino/qt-western-wilds-megaways",
    },
    "Waltz Beauty": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Waltz Beauty",
      name: "Waltz Beauty",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Waltz-Beauty.png",
      href: "/casino/qt-waltz-beauty",
    },
    "Vegas Hold & Win": {
      code: "67722",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vegas Hold & Win",
      name: "Vegas Hold & Win",
      providerName: "Qtech",
      imgUrl: "/images/qtechWCNew/Vegas-Hold-&-Win.png",
      href: "/casino/qt-vegas-hold-and-win",
    },
  },

  qtechslotstab: {
    ZombiesAttheDoor: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Zombies At the Door",
      name: "Zombies At the Door",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/ZombiesAttheDoor.webp",
      href: "/casino/qt-lucky-7",
    },
    Xibalba: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Xibalba",
      name: "Xibalba",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Xibalba.webp",
      href: "/casino/qt-xibalba",
    },
    WildDuel: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Duel",
      name: "Wild Duel",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/WildDuel.webp",
      href: "/casino/qt-wild-duel",
    },
    Wild1: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild 1",
      name: "Wild 1",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Wild1.webp",
      href: "/casino/qt-wild-1",
    },
    WildBard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Bard",
      name: "Wild Bard",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/WildBard.webp",
      href: "/casino/qt-wild-bard",
    },
    WaterBlox: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Water Blox",
      name: "Water Blox",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/WaterBlox.webp",
      href: "/casino/qt-water-blox",
    },
    VoodooHex: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Voodoo Hex",
      name: "Voodoo Hex",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/VoodooHex.webp",
      href: "/casino/qt-voodoo-hex",
    },
    ThunderHawk: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thunder Hawk",
      name: "Thunder Hawk",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/ThunderHawk.webp",
      href: "/casino/qt-thunder-hawk",
    },
    Valkyries: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Valkyries",
      name: "Valkyries",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Valkyries.webp",
      href: "/casino/qt-valkyries",
    },
    TheMafiosi: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Mafiosi",
      name: "The Mafiosi",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TheMafiosi.webp",
      href: "/casino/qt-the-mafiosi",
    },
    TheLegendofMusashi: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Legend of Musashi",
      name: "The Legend of Musashi",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TheLegendofMusashi.webp",
      href: "/casino/qt-the-legend-of-musashi",
    },
    SteamworksTheWorkshop: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Steamworks: The Workshop",
      name: "Steamworks: The Workshop",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/SteamworksTheWorkshop.webp",
      href: "/casino/qt-steamworks-the-workshop",
    },
    SteamworksGearsofFortune: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Steamworks: Gears of Fortune",
      name: "Steamworks: Gears of Fortune",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/SteamworksGearsofFortune.webp",
      href: "/casino/qt-steamworks-gears-of-fortune",
    },
    SheriffColt: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sheriff Colt",
      name: "Sheriff Colt",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/SheriffColt.webp",
      href: "/casino/qt-sheriff-colt",
    },
    SandsofDestiny: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sands of Destiny",
      name: "Sands of Destiny",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/SandsofDestiny.webp",
      href: "/casino/qt-sands-of-destiny",
    },
    RomeTheConquerors: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rome - The Conquerors",
      name: "Rome - The Conquerors",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/RomeTheConquerors.webp",
      href: "/casino/qt-rome-the-conquerors",
    },
    // RobinSherwoodMarauders: {
    //   code: "98566",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Robin - Sherwood Marauders",
    //   name: "Robin - Sherwood Marauders",
    //   providerName: "qtech",
    //   imgUrl: "/images/qtechslots/RobinSherwoodMarauders.webp",
    //   href: "/casino/qt-robin-sherwood-marauders-u7988",
    // },
    RobinNottinghamRaiders: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Robin - Nottingham Raiders",
      name: "Robin - Nottingham Raiders",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/RobinNottinghamRaiders.webp",
      href: "/casino/qt-robin-nottingham-raiders-u3290",
    },
    PunchClub: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Punch Club",
      name: "Punch Club",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/PunchClub.webp",
      href: "/casino/qt-punch-club",
    },
    Precious7: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Precious 7",
      name: "Precious 7",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Precious7.webp",
      href: "/casino/qt-precious-7",
    },
    PopCopScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pop Cop Scratchcard",
      name: "Pop Cop Scratchcard",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/PopCopScratchcard.webp",
      href: "/casino/qt-pop-cop-scratchcard",
    },
    PopCop: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pop Cop",
      name: "Pop Cop",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/PopCop.webp",
      href: "/casino/qt-pop-cop",
    },
    PeterHunter: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Peter Hunter",
      name: "Peter Hunter",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/PeterHunter.webp",
      href: "/casino/qt-peter-hunter",
    },
    Oops: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Oops",
      name: "Oops",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/Oops.webp",
      href: "/casino/qt-oops",
    },
    MutagenesScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mutagenes Scratchcard",
      name: "Mutagenes Scratchcard",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/MutagenesScratchcard.webp",
      href: "/casino/qt-mutagenes-scratchcard",
    },
    Mutagenes: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mutagenes",
      name: "Mutagenes",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/Mutagenes.webp",
      href: "/casino/qt-mutagenes",
    },
    MonsterBlox: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Monster Blox",
      name: "Monster Blox",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/MonsterBlox.webp",
      href: "/casino/qt-monster-blox",
    },
    MuddyWaters: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Muddy Waters",
      name: "Muddy Waters",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/MuddyWaters.webp",
      href: "/casino/qt-muddy-waters",
    },
    Kaiser: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaiser",
      name: "Kaiser",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/Kaiser.webp",
      href: "/casino/qt-kaiser",
    },
    JohnanLegendarian: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Johnan Legendarian",
      name: "Johnan Legendarian",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/JohnanLegendarian.webp",
      href: "/casino/qt-johnan-legendarian-u7627",
    },
    GunpowderScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gunpowder Scratchcard",
      name: "Gunpowder Scratchcard",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/GunpowderScratchcard.webp",
      href: "/casino/qt-gunpowder-scratchcard",
    },
    Gunpowder: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gunpowder",
      name: "Gunpowder",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/Gunpowder.webp",
      href: "/casino/qt-gunpowder",
    },
    GnomesandGiantsScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gnomes and Giants Scratchcard",
      name: "Gnomes and Giants Scratchcard",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/GnomesandGiantsScratchcard.webp",
      href: "/casino/qt-gnomes-and-giants-scratchcard",
    },
    GhostFatherScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ghost Father Scratchcard",
      name: "Ghost Father Scratchcard",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/GhostFatherScratchcard.webp",
      href: "/casino/qt-ghost-father-scratchcard",
    },
    GhostFather: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ghost Father",
      name: "Ghost Father",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/GhostFather.webp",
      href: "/casino/qt-ghost-father",
    },
    FrozenAge: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Frozen Age",
      name: "Frozen Age",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/FrozenAge.webp",
      href: "/casino/qt-frozen-age",
    },
    EvilDevil: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Evil Devil",
      name: "Evil Devil",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/EvilDevil.webp",
      href: "/casino/qt-evil-devil",
    },
    EpicHellas: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Epic Hellas",
      name: "Epic Hellas",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/EpicHellas.webp",
      href: "/casino/qt-epic-hellas",
    },
    DungeonTower: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dungeon Tower",
      name: "Dungeon Tower",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/DungeonTower.webp",
      href: "/casino/qt-dungeon-tower",
    },
    DragonBlox: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Blox",
      name: "Dragon Blox",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/DragonBlox.webp",
      href: "/casino/qt-dragon-blox",
    },
    DCirque: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "DCirque",
      name: "DCirque",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/DCirque.webp",
      href: "/casino/qt-dcirque",
    },
    CoinBloxScratchcard: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Blox Scratchcard",
      name: "Coin Blox Scratchcard",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/CoinBloxScratchcard.webp",
      href: "/casino/qt-coin-blox-scratchcard",
    },
    CoinBlox: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Blox",
      name: "Coin Blox",
      providerName: "Qtech",
      imgUrl: "/images/qtechslots/CoinBlox.webp",
      href: "/casino/qt-coin-blox",
    },
    Barbarossa: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Barbarossa",
      name: "Barbarossa",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Barbarossa.webp",
      href: "/casino/qt-barbarossa",
    },
    Animafia: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Animafia",
      name: "Animafia",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Animafia.webp",
      href: "/casino/qt-animafia",
    },
    XBomber: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "X-Bomber",
      name: "X-Bomber",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/XBomber.webp",
      href: "/casino/qt-x-bomber",
    },
    WonWonRich: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Won Won Rich",
      name: "Won Won Rich",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/WonWonRich.webp",
      href: "/casino/qt-won-won-rich",
    },
    Wizardry: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wizardry",
      name: "Wizardry",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/Wizardry.webp",
      href: "/casino/qt-wizardry-u6084",
    },
    VeggiesPlot: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Veggies Plot",
      name: "Veggies Plot",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/VeggiesPlot.webp",
      href: "/casino/qt-veggies-plot",
    },
    TrippyMushrooms: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trippy Mushrooms",
      name: "Trippy Mushrooms",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TrippyMushrooms.webp",
      href: "/casino/qt-trippy-mushrooms",
    },
    TreasureTiger: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Treasure Tiger",
      name: "Treasure Tiger",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TreasureTiger.webp",
      href: "/casino/qt-treasure-tiger",
    },
    ToyWorld: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Toy World",
      name: "Toy World",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/ToyWorld.webp",
      href: "/casino/qt-toy-world",
    },
    TombHeroes: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tomb Heroes",
      name: "Tomb Heroes",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TombHeroes.webp",
      href: "/casino/qt-tomb-heroes",
    },
    TheWildFour: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Wild Four",
      name: "The Wild Four",
      providerName: "qtech",
      imgUrl: "/images/qtechslots/TheWildFour.webp",
      href: "/casino/qt-the-wild-four",
    },
  },

  qtechcrashtab: {
    PutterKing: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Putter King",
      name: "Putter King",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/PutterKing.webp",
      href: "/casino/qt-putter-king",
    },
    PufferSwimming: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Puffer Swimming",
      name: "Puffer Swimming",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/PufferSwimming.webp",
      href: "/casino/qt-puffer-swimming",
    },
    KickPumpkin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kick Pumpkin",
      name: "Kick Pumpkin",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/KickPumpkin.webp",
      href: "/casino/qt-kick-pumpkin",
    },
    InfinityX: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Infinity X",
      name: "Infinity X",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/InfinityX.webp",
      href: "/casino/qt-infinity-x",
    },
    HomeRunX: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Home Run X",
      name: "Home Run X",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/HomeRunX.webp",
      href: "/casino/qt-home-run-x",
    },
    GolfMaster: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golf Master",
      name: "Golf Master",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/GolfMaster.webp",
      href: "/casino/qt-golf-master",
    },
    EndorserofThor: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Endorser of Thor",
      name: "Endorser of Thor",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/EndorserofThor.webp",
      href: "/casino/qt-endorser-of-thor",
    },
    SubmarineBattle: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Submarine Battle",
      name: "Submarine Battle",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/SubmarineBattle.webp",
      href: "/casino/qt-submarine-battle",
    },
    BearRun: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bear Run",
      name: "Bear Run",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/BearRun.webp",
      href: "/casino/qt-bear-run",
    },
    AquaMotoRacing: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aqua Moto Racing",
      name: "Aqua Moto Racing",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/AquaMotoRacing.webp",
      href: "/casino/qt-aqua-moto-racing",
    },
    HypersonicX: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hypersonic X",
      name: "Hypersonic X",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/HypersonicX.webp",
      href: "/casino/qt-kag-hypersonicx",
    },
    RedBaron: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Red Baron",
      name: "Red Baron",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/RedBaron.webp",
      href: "/casino/qt-kag-redbaron",
    },
    ImpossibleX: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Impossible X",
      name: "Impossible X",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/ImpossibleX.webp",
      href: "/casino/qt-kag-impossiblex",
    },
    // OutsourcedSlashGame: {
    //   code: "98566",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Outsourced: Slash Game",
    //   name: "Outsourced: Slash Game",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechcrash/OutsourcedSlashGame.webp",
    //   href: "/casino/qt-outsourced-slash-game",
    // },
    Munchies: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Munchies",
      name: "Munchies",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/Munchies.webp",
      href: "/casino/qt-munchies",
    },
    AcrosstheUniverse: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Across the Universe",
      name: "Across the Universe",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/AcrosstheUniverse.webp",
      href: "/casino/qt-across-the-universe",
    },
    DannyDollar: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Danny Dollar",
      name: "Danny Dollar",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/DannyDollar.webp",
      href: "/casino/qt-hak-dannydollar",
    },
    Gunmancrash: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gunman crash",
      name: "Gunman crash",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/Gunmancrash.webp",
      href: "/casino/qt-msg-gunmancrash",
    },
    CrashHamsterCrash: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Hamster Crash",
      name: "Crash Hamster Crash",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/CrashHamsterCrash.webp",
      href: "/casino/qt-msg-crashhamstercrash",
    },
    // BuckingRider: {
    //   code: "98566",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Bucking Rider",
    //   name: "Bucking Rider",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechcrash/BuckingRider.webp",
    //   href: "/casino/qt-png-buckingrider",
    // },
    PaperLanternsCrashGame: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Paper Lanterns: Crash Game",
      name: "Paper Lanterns: Crash Game",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/PaperLanternsCrashGame.webp",
      href: "/casino/qt-msg-paperlanternscrashgame",
    },
    SpeedCrash: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed Crash",
      name: "Speed Crash",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/SpeedCrash.webp",
      href: "/casino/qt-hak-speedcrash",
    },
    Limbo: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/Limbo.webp",
      href: "/casino/qt-hak-limbo",
    },
    Skyward: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sky ward",
      name: "Sky ward",
      providerName: "Qtech",
      imgUrl: "/images/qtechcrash/Skyward.webp",
      href: "/casino/qt-sky-ward",
    },
    // Maverick: {
    //   code: "98566",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Maverick",
    //   name: "Maverick",
    //   providerName: "Qtech",
    //   imgUrl: "/images/qtechcrash/Maverick.webp",
    //   href: "/casino/qt-maverick",
    // },
  },

  onlyplayslottab: {
    TrainofGoldXMasHoldAndWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Train of Gold X-Mas: Hold & Win",
      name: "Train of Gold X-Mas: Hold & Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/TrainofGoldXMasHoldAndWin.webp",
      href: "/casino/gt-train-of-gold-x-mas-hold-and-win",
    },
    ChickenPlinko: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chicken Plinko",
      name: "Chicken Plinko",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/ChickenPlinko.webp",
      href: "/casino/gt-chicken-plinko",
    },
    MangoMulti7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mango Multi 7s Hold and Win",
      name: "Mango Multi 7s Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/MangoMulti7sHoldandWin.webp",
      href: "/casino/gt-mango-multi-7s-hold-and-win",
    },
    HorusFirePrizeTower: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Horus Fire PrizeTower",
      name: "Horus Fire PrizeTower",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/HorusFirePrizeTower.webp",
      href: "/casino/gt-horus-fire-prizetower",
    },
    NinjazvsNarcos2: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ninjaz vs Narcos 2",
      name: "Ninjaz vs Narcos 2",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/NinjazvsNarcos2.webp",
      href: "/casino/gt-ninjaz-vs-narcos-2",
    },
    MooncakeDragonsHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mooncake Dragons Hold and Win",
      name: "Mooncake Dragons Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/MooncakeDragonsHoldandWin.webp",
      href: "/casino/gt-mooncake-dragons-hold-and-win",
    },
    JokerFright7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Joker Fright 7s",
      name: "Joker Fright 7s",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/JokerFright7s.webp",
      href: "/casino/gt-joker-fright-7s",
    },
    EmeraldGlory7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Emerald Glory 7s",
      name: "Emerald Glory 7s",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/EmeraldGlory7s.webp",
      href: "/casino/gt-emerald-glory-7s",
    },
    BisonMadnessPrizeTower: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bison Madness PrizeTower",
      name: "Bison Madness PrizeTower",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/BisonMadnessPrizeTower.webp",
      href: "/casino/gt-bison-madness-prizetower",
    },
    Blazing3ScarabsHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Blazing Scarabs Hold and Win",
      name: "3 Blazing Scarabs Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/Blazing3ScarabsHoldandWin.webp",
      href: "/casino/gt-3-blazing-scarabs-hold-and-win",
    },
    HalloweenTrainHoldAndWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Halloween Train: Hold & Win",
      name: "Halloween Train: Hold & Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/HalloweenTrainHoldAndWin.webp",
      href: "/casino/gt-halloween-train-hold-and-win",
    },
    FishingSplash: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fishing Splash",
      name: "Fishing Splash",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/FishingSplash.webp",
      href: "/casino/gt-fishing-splash",
    },
    MultiBlitz7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multi Blitz 7s",
      name: "Multi Blitz 7s",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/MultiBlitz7s.webp",
      href: "/casino/gt-multi-blitz-7s",
    },
    LadyLemonFruits: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lady Lemon Fruits",
      name: "Lady Lemon Fruits",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/LadyLemonFruits.webp",
      href: "/casino/gt-lady-lemon-fruits",
    },
    JokerCatcher7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Joker Catcher 7s",
      name: "Joker Catcher 7s",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/JokerCatcher7s.webp",
      href: "/casino/gt-joker-catcher-7s",
    },
    IndianAdventureInfinityfreespins: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Indian Adventure: Infinity freespins",
      name: "Indian Adventure: Infinity freespins",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/IndianAdventureInfinityfreespins.webp",
      href: "/casino/gt-indian-adventure-infinity-freespins",
    },
    GoldenPiggyFarm: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Piggy Farm",
      name: "Golden Piggy Farm",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/GoldenPiggyFarm.webp",
      href: "/casino/gt-golden-piggy-farm",
    },
    // GoldOktoberfest: {
    //   code: "98566",
    //   casino: "aura",
    //   provider: "aura",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Gold Oktoberfest",
    //   name: "Gold Oktoberfest",
    //   providerName: "Qtech",
    //   imgUrl: "/images/onlyplayslot/GoldOktoberfest.webp",
    //   href: "/casino/gt-gold-oktoberfest7",
    // },
    GoldofBaboon: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold of Baboon",
      name: "Gold of Baboon",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/GoldofBaboon.webp",
      href: "/casino/gt-gold-of-baboon",
    },
    FootballTap: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Football Tap",
      name: "Football Tap",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/FootballTap.webp",
      href: "/casino/gt-football-tap",
    },
    FireCrown: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fire Crown",
      name: "Fire Crown",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/FireCrown.webp",
      href: "/casino/gt-fire-crown",
    },
    DiamondStyle: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond Style",
      name: "Diamond Style",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/DiamondStyle.webp",
      href: "/casino/gt-diamond-style",
    },
    CloverSupremeHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Clover Supreme Hold and Win",
      name: "Clover Supreme Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/CloverSupremeHoldandWin.webp",
      href: "/casino/gt-clover-supreme-hold-and-win",
    },
    BisonadoPrizeMatch: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bisonado PrizeMatch",
      name: "Bisonado PrizeMatch",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/BisonadoPrizeMatch.webp",
      href: "/casino/gt-bisonado-prizematch",
    },
    SoloReelBlitz: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "SoloReel Blitz",
      name: "SoloReel Blitz",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/SoloReelBlitz.webp",
      href: "/casino/gt-soloreel-blitz",
    },
    SoccerStormHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Soccer Storm Hold and Win",
      name: "Soccer Storm Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/SoccerStormHoldandWin.webp",
      href: "/casino/gt-soccer-storm-hold-and-win",
    },
    Firedream7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Firedream 7s Hold and Win",
      name: "Firedream 7s Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/Firedream7sHoldandWin.webp",
      href: "/casino/gt-firedream-7s-hold-and-win",
    },
    EagleHonor7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Eagle Honor 7s",
      name: "Eagle Honor 7s",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/EagleHonor7s.webp",
      href: "/casino/gt-eagle-honor-7s",
    },
    ChiliMax7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chili Max 7s Hold and Win",
      name: "Chili Max 7s Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/ChiliMax7sHoldandWin.webp",
      href: "/casino/gt-chili-max-7s-hold-and-win",
    },
    TouchdownThunderHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Touchdown Thunder Hold and Win",
      name: "Touchdown Thunder Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/TouchdownThunderHoldandWin.webp",
      href: "/casino/gt-touchdown-thunder-hold-and-win",
    },
    StPatricksAquaMagicHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "St. Patrick's Aqua Magic Hold and Win",
      name: "St. Patrick's Aqua Magic Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/StPatricksAquaMagicHoldandWin.webp",
      href: "/casino/gt-st-patricks-aqua-magic-hold-and-win",
    },
    SnakeFortuneHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Snake Fortune Hold and Win",
      name: "Snake Fortune Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/SnakeFortuneHoldandWin.webp",
      href: "/casino/gt-snake-fortune-hold-and-win",
    },
    SkullSpirit7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Skull Spirit 7s Hold and Win",
      name: "Skull Spirit 7s Hold and Win",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/SkullSpirit7sHoldandWin.webp",
      href: "/casino/gt-skull-spirit-7s-hold-and-win",
    },
    PinataBurst: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pinata Burst",
      name: "Pinata Burst",
      providerName: "Qtech",
      imgUrl: "/images/onlyplayslot/PinataBurst.webp",
      href: "/casino/gt-pinata-burst",
    },
    PhantomFamilyPrizeMatch: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Phantom Family PrizeMatch",
      name: "Phantom Family PrizeMatch",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/PhantomFamilyPrizeMatch.webp",
      href: "/casino/gt-phantom-family-prizematch",
    },
    JokerSpark7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Joker Spark 7s",
      name: "Joker Spark 7s",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/JokerSpark7s.webp",
      href: "/casino/gt-joker-spark-7s",
    },
    JokerFortuneBlitz2: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Joker Fortune Blitz 2",
      name: "Joker Fortune Blitz 2",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/JokerFortuneBlitz2.webp",
      href: "/casino/gt-joker-fortune-blitz-2",
    },
    Jingle7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jingle 7s Hold and Win",
      name: "Jingle 7s Hold and Win",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/Jingle7sHoldandWin.webp",
      href: "/casino/gt-jingle-7s-hold-and-win",
    },
    HyperNeko7s: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hyper Neko 7s",
      name: "Hyper Neko 7s",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/HyperNeko7s.webp",
      href: "/casino/gt-hyper-neko-7s",
    },
    HomelandFortune7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hyper Neko 7s",
      name: "Hyper Neko 7s",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/HomelandFortune7sHoldandWin.webp",
      href: "/casino/gt-hyper-neko-7s",
    },
    HellChefGoesFishing: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hell Chef Goes Fishing",
      name: "Hell Chef Goes Fishing",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/HellChefGoesFishing.webp",
      href: "/casino/gt-hell-chef-goes-fishing",
    },
    HeartsBountyBlitz: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hearts Bounty Blitz",
      name: "Hearts Bounty Blitz",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/HeartsBountyBlitz.webp",
      href: "/casino/gt-hearts-bounty-blitz",
    },
    HauntedJokerHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Haunted Joker Hold and Win",
      name: "Haunted Joker Hold and Win",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/HauntedJokerHoldandWin.webp",
      href: "/casino/gt-haunted-joker-hold-and-win",
    },
    FishlineLootHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fishline Loot Hold and Win",
      name: "Fishline Loot Hold and Win",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/FishlineLootHoldandWin.webp",
      href: "/casino/gt-fishline-loot-hold-and-win",
    },
    FireboltMax7sHoldandWin: {
      code: "98566",
      casino: "aura",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Firebolt Max 7s Hold and Win",
      name: "Firebolt Max 7s Hold and Win",
      providerName: "qtech",
      imgUrl: "/images/onlyplayslot/FireboltMax7sHoldandWin.webp",
      href: "/casino/gt-firebolt-max-7s-hold-and-win",
    },
  },

  // vivoslotstab: {
  //   LuckyNewYear: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky New Year",
  //     name: "Lucky New Year",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckyNewYear.webp",
  //     href: "/casino/pragmaticplay-lucky-new-year",
  //   },
  //   JurassicGiants: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Jurassic Giants",
  //     name: "Jurassic Giants",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/JurassicGiants.webp",
  //     href: "/casino/pragmaticplay-jurassic-giants",
  //   },
  //   KillorDie: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Kill or Die",
  //     name: "Kill or Die",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/KillorDie.webp",
  //     href: "/casino/pragmaticplay-kill-or-die",
  //   },
  //   KingdomofAsgard: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Kingdom of Asgard",
  //     name: "Kingdom of Asgard",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/KingdomofAsgard.webp",
  //     href: "/casino/pragmaticplay-kingdom-of-asgard",
  //   },
  //   KingdomofAtlantisJackpotPlay: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Kingdom of Atlantis Jackpot Play",
  //     name: "Kingdom of Atlantis Jackpot Play",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/KingdomofAtlantisJackpotPlay.webp",
  //     href: "/casino/pragmaticplay-kingdom-of-atlantis-jackpot-play",
  //   },
  //   // KingdomofTheDead: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Kingdom of The Dead",
  //   //   name: "Kingdom of The Dead",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/KingdomofTheDead.webp",
  //   //   href: "/casino/pragmaticplay-kingdom-of-the-dead",
  //   // },
  //   KnightHotSpotz: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Knight Hot Spotz",
  //     name: "Knight Hot Spotz",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/KnightHotSpotz.webp",
  //     href: "/casino/pragmaticplay-knight-hot-spotz",
  //   },
  //   KoiBonanzaJackpotPlay: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Koi Bonanza Jackpot Play",
  //     name: "Koi Bonanza Jackpot Play",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/KoiBonanzaJackpotPlay.webp",
  //     href: "/casino/pragmaticplay-koi-bonanza-jackpot-play",
  //   },
  //   // KoiPond: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Koi Pond",
  //   //   name: "Koi Pond",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/KoiPond.webp",
  //   //   href: "/casino/pragmaticplay-koi-pond",
  //   // },
  //   LadbrokesHeat: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Ladbrokes Heat",
  //     name: "Ladbrokes Heat",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LadbrokesHeat.webp",
  //     href: "/casino/pragmaticplay-ladbrokes-heat",
  //   },
  //   LadyBugLuck: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Ladybug Luck",
  //     name: "Ladybug Luck",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LadyBugLuck.webp",
  //     href: "/casino/pragmaticplay-ladybug-luck",
  //   },
  //   LadyDestinyMegaways: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lady D Megaways",
  //     name: "Lady D Megaways",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LadyDestinyMegaways.webp",
  //     href: "/casino/pragmaticplay-lady-d-megaways",
  //   },
  //   // LadyGodiva: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Lady Godiva",
  //   //   name: "Lady Godiva",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LadyGodiva.webp",
  //   //   href: "/casino/pragmaticplay-lady-godiva",
  //   // },
  //   LaMokaWildPowernudge: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "La Moka Wild Powernudge",
  //     name: "La Moka Wild Powernudge",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LaMokaWildPowernudge.webp",
  //     href: "/casino/pragmaticplay-la-moka-wild-powernudge",
  //   },
  //   // LampOfInfinity: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Lamp Of Infinity",
  //   //   name: "Lamp Of Infinity",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LampOfInfinity.webp",
  //   //   href: "/casino/pragmaticplay-lamp-of-infinity",
  //   // },
  //   LaughingFortune: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Laughing Fortune",
  //     name: "Laughing Fortune",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LaughingFortune.webp",
  //     href: "/casino/pragmaticplay-laughing-fortune",
  //   },
  //   LegendofGaruda: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Legend of Garuda",
  //     name: "Legend of Garuda",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LegendofGaruda.webp",
  //     href: "/casino/pragmaticplay-legend-of-garuda",
  //   },
  //   // LegendofHeroes: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Legend of Heroes",
  //   //   name: "Legend of Heroes",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LegendofHeroes.webp",
  //   //   href: "/casino/pragmaticplay-legend-of-heroes",
  //   // },
  //   // LeprechaunCarol: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Leprechaun Carol",
  //   //   name: "Leprechaun Carol",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LeprechaunCarol.webp",
  //   //   href: "/casino/pragmaticplay-leprechaun-carol",
  //   // },
  //   // LeprechaunSong: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Leprechaun Song",
  //   //   name: "Leprechaun Song",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LeprechaunSong.webp",
  //   //   href: "/casino/pragmaticplay-leprechaun-song",
  //   // },
  //   LittleGemHoldandSpin: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Little Gem Hold and Spin",
  //     name: "Little Gem Hold and Spin",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LittleGemHoldandSpin.webp",
  //     href: "/casino/pragmaticplay-little-gem-hold-and-spin",
  //   },
  //   LobsterBobsCrazyCrabShack: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lobster Bobs Crazy Crab Shack",
  //     name: "Lobster Bobs Crazy Crab Shack",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LobsterBobsCrazyCrabShack.webp",
  //     href: "/casino/pragmaticplay-lobster-bobs-crazy-crab-shack",
  //   },
  //   LobsterBobsSeaFoodandWinIt: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lobster Bob's Sea Food and Win It",
  //     name: "Lobster Bob's Sea Food and Win It",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LobsterBobsSeaFoodandWinIt.webp",
  //     href: "/casino/pragmaticplay-lobster-bobs-sea-food-and-win-it",
  //   },
  //   LokisRiches: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Loki's Riches",
  //     name: "Loki's Riches",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LokisRiches.webp",
  //     href: "/casino/pragmaticplay-lokis-riches",
  //   },
  //   LuckyDragonBall: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Dragon Ball",
  //     name: "Lucky Dragon Ball",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckyDragonBall.webp",
  //     href: "/casino/pragmaticplay-lucky-dragon-ball",
  //   },
  //   LuckyDragons: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Dragons",
  //     name: "Lucky Dragons",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckyDragons.webp",
  //     href: "/casino/pragmaticplay-lucky-dragons",
  //   },
  //   // LuckyFishingMegaways: {
  //   //   code: "",
  //   //   casino: "vivo",
  //   //   provider: "vivo",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   alt: "Lucky Fishing Megaways",
  //   //   name: "Lucky Fishing Megaways",
  //   //   providerName: "qtech",
  //   //   imgUrl: "/images/vivoslots/LuckyFishingMegaways.webp",
  //   //   href: "/casino/pragmaticplay-lucky-fishing-megaways",
  //   // },
  //   LuckyGraceAndCharm: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Grace And Charm",
  //     name: "Lucky Grace And Charm",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckyGraceAndCharm.webp",
  //     href: "/casino/pragmaticplay-lucky-grace-and-charm",
  //   },
  //   LuckyLightning: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Lightning",
  //     name: "Lucky Lightning",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckyLightning.webp",
  //     href: "/casino/pragmaticplay-lucky-lightning",
  //   },
  //   LuckysWildPub: {
  //     code: "",
  //     casino: "vivo",
  //     provider: "vivo",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky’s Wild Pub",
  //     name: "Lucky’s Wild Pub",
  //     providerName: "qtech",
  //     imgUrl: "/images/vivoslots/LuckysWildPub.webp",
  //     href: "/casino/pragmaticplay-luckys-wild-pub",
  //   },
  // },

  // redtigertab: {
  //   NinjaWays: {
  //     href: "/casino/ezgrt-ninja-ways",
  //     code: "1100166",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Ninja-Ways.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Ninja Ways",
  //     providerName: "slots",
  //   },
  //   PathofDestiny: {
  //     href: "/casino/ezgrt-path-of-destiny",
  //     code: "1100167",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Path-of-Destiny.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Path of Destiny",
  //     providerName: "slots",
  //   },
  //   PersianFortune: {
  //     href: "/casino/ezgrt-persian-fortune",
  //     code: "1100168",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Persian-Fortune.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Persian Fortune",
  //     providerName: "slots",
  //   },
  //   ReelHeist: {
  //     href: "/casino/ezgrt-reel-heist",
  //     code: "1100169",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Reel-Heist.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel Heist",
  //     providerName: "slots",
  //   },
  //   ReelKingMegaways: {
  //     href: "/casino/ezgrt-reel-king-mega",
  //     code: "1100052",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Reel_King_Mega.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel King Mega",
  //     providerName: "slots",
  //   },
  //   RobinHoodWildForest: {
  //     href: "/casino/ezgrt-robin-hoods-wild-forest",
  //     code: "1100170",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Robin-Hood`s-Wild-Forest.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Robin Hood`s Wild Forest",
  //     providerName: "slots",
  //   },
  //   SnowWild: {
  //     href: "/casino/ezgrt-snow-wild-and-the-7-features",
  //     code: "1100171",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Snow-Wild-And-The-7-Features.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Snow Wild And The 7 Features",
  //     providerName: "slots",
  //   },
  //   SylvanSpirits: {
  //     href: "/casino/ezgrt-sylvan-spirits",
  //     code: "1100172",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Sylvan-Spirits.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Sylvan Spirits",
  //     providerName: "slots",
  //   },
  //   TheGreatestTrainRobbery: {
  //     href: "/casino/ezgrt-the-greatest-train-robbery",
  //     code: "1100173",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/The-Greatest-Train-Robbery.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Greatest Train Robbery",
  //     providerName: "slots",
  //   },
  //   TheWildHatter: {
  //     href: "/casino/ezgrt-the-wild-hatter",
  //     code: "1100174",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/The-Wild-Hatter.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Wild Hatter",
  //     providerName: "slots",
  //   },
  //   ThorLightning: {
  //     href: "/casino/ezgrt-thors-lightning",
  //     code: "1100175",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Thor`s-Lightning.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Thor`s Lightning",
  //     providerName: "slots",
  //   },
  //   DragonLuck: {
  //     href: "/casino/ezgrt-dragons-luck",
  //     code: "1100001",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Dragon's-Luck.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck",
  //     providerName: "slots",
  //   },
  //   DragonLuckReel: {
  //     href: "/casino/ezgrt-dragons-luck-power-reels",
  //     code: "1100002",
  //     casino: "ezugi",
  //     imgUrl: "/images/slots/Dragon's-Luck-Power-Reels.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck Power Reels",
  //     providerName: "slots",
  //   },
  // },

  ezugiredtigertab: {
    DragonsLuck: {
      href: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DragonsLuck.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck",
      providerName: "slots",
    },
    DragonsLuckPowerReels: {
      href: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Power Reels",
      providerName: "slots",
    },
    Nights10001: {
      href: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/10001Nights.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "10,001 Nights",
      providerName: "slots",
    },
    GodOfWealth: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GodOfwealth-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    PiratesPlentyBattleforGold: {
      href: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty Battle for Gold",
      providerName: "slots",
    },
    ChineseTreasures: {
      href: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/chinesetreasure-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    FortuneHouse: {
      href: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/FortuneHouse.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune House",
      providerName: "slots",
    },
    DragonsFire: {
      href: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DragonsFire.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire",
      providerName: "slots",
    },
    MagicGate: {
      href: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MagicGate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Magic Gate",
      providerName: "slots",
    },
    LuckyFortuneCat: {
      href: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LuckyFortuneCat.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Fortune Cat",
      providerName: "slots",
    },
    DragonsLuckDeluxe: {
      href: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Deluxe",
      providerName: "slots",
    },
    EpicJourney: {
      href: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/EpicJourney.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Epic Journey",
      providerName: "slots",
    },
    PhoenixFirePowerReels: {
      href: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Phoenix Fire Power Reels",
      providerName: "slots",
    },
    GoldenTemple: {
      href: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GoldenTemple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Temple",
      providerName: "slots",
    },
    PiratesPlenty: {
      href: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PiratesPlenty.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty",
      providerName: "slots",
    },
    GoldenOffer: {
      href: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GoldenOffer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Offer",
      providerName: "slots",
    },
    RAsLegend: {
      href: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RAsLegend.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "RA's Legend",
      providerName: "slots",
    },
    GonzosQuestMegaways: {
      href: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GonzosQuestMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gonzo's Quest Megaways",
      providerName: "slots",
    },
    RainbowJackpots: {
      href: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RainbowJackpots.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots",
      providerName: "slots",
    },
    MegaPyramid: {
      href: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MegaPyramid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Pyramid",
      providerName: "slots",
    },
    WarOfGods: {
      href: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WarOfGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "War Of Gods",
      providerName: "slots",
    },
    Strike777: {
      href: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/777Strike.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "777 Strike",
      providerName: "slots",
    },
    AncientsBlessing: {
      href: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/AncientsBlessing.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ancients Blessing",
      providerName: "slots",
    },
    AurumCodex: {
      href: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/AurumCodex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aurum Codex",
      providerName: "slots",
    },
    BettyBorisandBoo: {
      href: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/BettyBorisandBoo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Betty, Boris and Boo",
      providerName: "slots",
    },
    // ZeusLightningPowerReels: {
    //   href: "/casino/ezgrt-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   imgUrl: "/images/slots/new/redtiger/ZeusLightningPower-Reels.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Zeus Lightning Power Reels",
    //   providerName: "slots",
    // },
    WingsofRa: {
      href: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WingsofRa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wings of Ra",
      providerName: "slots",
    },
    TreasureMine: {
      href: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/TreasureMine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Treasure Mine",
      providerName: "slots",
    },
    ThorsVengeance: {
      href: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ThorsVengeance.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor's Vengeance",
      providerName: "slots",
    },
    RegalStreak: {
      href: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RegalStreak.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Streak",
      providerName: "slots",
    },
    RegalBeasts: {
      href: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RegalBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Beasts",
      providerName: "slots",
    },
    ReelKingMega: {
      href: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ReelKingMega.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel King Mega",
      providerName: "slots",
    },
    ReelKeeper: {
      href: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ReelKeeper.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Keeper",
      providerName: "slots",
    },
    RainbowJackpotsPowerLines: {
      href: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots Power Lines",
      providerName: "slots",
    },
    MysteryReels: {
      href: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MysteryReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels",
      providerName: "slots",
    },
    PiggyRichesMegaways: {
      href: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PiggyRichesMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches Megaways",
      providerName: "slots",
    },
    JingleBells: {
      href: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/JingleBells.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells",
      providerName: "slots",
    },
    JackinaPot: {
      href: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/JackinaPot.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack in a Pot",
      providerName: "slots",
    },
    FiveStar: {
      href: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/FiveStar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Star",
      providerName: "slots",
    },
    BountyRaid: {
      href: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/BountyRaid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bounty Raid",
      providerName: "slots",
    },
    CashUltimate: {
      href: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CashUltimate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Ultimate",
      providerName: "slots",
    },
    CashVolt: {
      href: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CashVolt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Volt",
      providerName: "slots",
    },
    DynamiteRiches: {
      href: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DynamiteRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dynamite Riches",
      providerName: "slots",
    },
    DiamondBlitz: {
      href: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DiamondBlitz.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamond Blitz",
      providerName: "slots",
    },
    DragonsFireMegaways: {
      href: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DragonsFireMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire Megaways",
      providerName: "slots",
    },
    Squad4: {
      href: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/4Squad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "4 Squad",
      providerName: "slots",
    },
    AgentRoyale: {
      href: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/AgentRoyale.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Agent Royale",
      providerName: "slots",
    },
    Families5: {
      href: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/5Families.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Families",
      providerName: "slots",
    },
    ArcadeBomb: {
      href: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ArcadeBomb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Arcade Bomb",
      providerName: "slots",
    },
    CinderellasBall: {
      href: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CinderellasBall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cinderella`s Ball",
      providerName: "slots",
    },
    Atlantis: {
      href: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/Atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Atlantis",
      providerName: "slots",
    },
    AztecSpins: {
      href: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/AztecSpins.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aztec Spins",
      providerName: "slots",
    },
    ClashoftheBeasts: {
      href: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ClashoftheBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Clash of the Beasts",
      providerName: "slots",
    },
    CirquedelaFortune: {
      href: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CirquedelaFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cirque de la Fortune",
      providerName: "slots",
    },
    CrazyGenie: {
      href: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CrazyGenie.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crazy Genie",
      providerName: "slots",
    },
    CrystalMirror: {
      href: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/CrystalMirror.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crystal Mirror",
      providerName: "slots",
    },
    DevilsNumber: {
      href: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DevilsNumber.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Devil`s Number",
      providerName: "slots",
    },
    DaVincisMystery: {
      href: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DaVincisMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Da Vinci`s Mystery",
      providerName: "slots",
    },
    DiceDiceDice: {
      href: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/DiceDiceDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice Dice Dice",
      providerName: "slots",
    },
    FiveStarsPowerReels: {
      href: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/FiveStarsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Stars Power Reels",
      providerName: "slots",
    },
    GemsGoneWild: {
      href: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GemsGoneWild.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild",
      providerName: "slots",
    },
    GemsGoneWildPowerReels: {
      href: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild Power Reels",
      providerName: "slots",
    },
    GoldenCryptex: {
      href: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GoldenCryptex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Cryptex",
      providerName: "slots",
    },
    GoldenLeprechaunMegaways: {
      href: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Leprechaun Megaways",
      providerName: "slots",
    },
    GrandWheel: {
      href: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GrandWheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Grand Wheel",
      providerName: "slots",
    },
    GoldenTsar: {
      href: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/GoldenTsar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Tsar",
      providerName: "slots",
    },
    HoardofPoseidon: {
      href: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/HoardofPoseidon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hoard of Poseidon",
      providerName: "slots",
    },
    JewelScarabs: {
      href: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/JewelScarabs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jewel Scarabs",
      providerName: "slots",
    },
    LegendofAthena: {
      href: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LegendofAthena.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Legend of Athena",
      providerName: "slots",
    },
    JingleBellsPowerReels: {
      href: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/JingleBellsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells Power Reels",
      providerName: "slots",
    },
    LuckyHalloween: {
      href: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LuckyHalloween.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Halloween",
      providerName: "slots",
    },
    LuckyLittleDevil: {
      href: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LuckyLittleDevil.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Little Devil",
      providerName: "slots",
    },
    LuckyValentine: {
      href: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LuckyValentine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Valentine",
      providerName: "slots",
    },
    LuckyWizard: {
      href: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/LuckyWizard.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Wizard",
      providerName: "slots",
    },
    Masquerade: {
      href: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/Masquerade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Masquerade",
      providerName: "slots",
    },
    MayanGods: {
      href: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MayanGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mayan Gods",
      providerName: "slots",
    },
    MegaDragon: {
      href: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MegaDragon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Dragon",
      providerName: "slots",
    },
    MegaJade: {
      href: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MegaJade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Jade",
      providerName: "slots",
    },
    MegaRise: {
      href: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MegaRise.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Rise",
      providerName: "slots",
    },
    MultiplierRiches: {
      href: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MultiplierRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Multiplier Riches",
      providerName: "slots",
    },
    MysteryReelsMegaways: {
      href: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/MysteryReelsMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels Megaways",
      providerName: "slots",
    },
    NinjaWays: {
      href: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/NinjaWays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ninja Ways",
      providerName: "slots",
    },
    PathofDestiny: {
      href: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PathofDestiny.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Path of Destiny",
      providerName: "slots",
    },
    PersianFortune: {
      href: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/PersianFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Persian Fortune",
      providerName: "slots",
    },
    ReelHeist: {
      href: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      href: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      href: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      href: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/SylvanSpirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      href: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      href: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/TheWildHatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      href: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      href: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/TikiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      href: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/VaultCracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      href: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/TotemLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      href: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WellofWishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      href: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/VaultofAnubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      href: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      href: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      href: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/YucatansMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      href: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      href: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/new/redtiger/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
  },
  inouttab: {
    Aviafly: {
      href: "/casino/io-aviafly",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Aviafly.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Aviafly",
      name: "Aviafly",
      providerName: "WorldCasino",
    },
    BalloniX: {
      href: "/casino/io-ballonix",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/BalloniX.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "BalloniX",
      name: "BalloniX",
      providerName: "WorldCasino",
    },
    Bubbles: {
      href: "/casino/io-bubbles",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Bubbles.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "WorldCasino",
    },
    ChickenRoad: {
      href: "/casino/io-chicken-road",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road",
      name: "Chicken Road",
      providerName: "WorldCasino",
    },
    ChickenRoad2: {
      href: "/casino/io-chicken-road-2",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoad2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road 2",
      name: "Chicken Road 2",
      providerName: "WorldCasino",
    },
    ChickenRoyal: {
      href: "/casino/io-chicken-royal",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoyal.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Royal",
      name: "Chicken Royal",
      providerName: "WorldCasino",
    },
    Crash: {
      href: "/casino/io-crash",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Crash.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Crash",
      name: "Crash",
      providerName: "WorldCasino",
    },
    ChickenRoadGold: {
      href: "/casino/io-chicken-road-gold",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoadGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road Gold",
      name: "Chicken Road Gold",
      providerName: "WorldCasino",
    },
    ChickenRoadVegas: {
      href: "/casino/io-chicken-road-vegas",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoadVegas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road Vegas",
      name: "Chicken Road Vegas",
      providerName: "WorldCasino",
    },
    Coinflip: {
      href: "/casino/io-coinflip",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Coinflip.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Coinflip",
      name: "Coinflip",
      providerName: "WorldCasino",
    },
    Cryptos: {
      href: "/casino/io-cryptos",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Cryptos.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Cryptos",
      name: "Cryptos",
      providerName: "WorldCasino",
    },
    GoblinTower: {
      href: "/casino/io-goblin-tower",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/GoblinTower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Goblin-tower",
      name: "Goblin-tower",
      providerName: "WorldCasino",
    },
    LuckyMines: {
      href: "/casino/io-lucky-mines",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/LuckyMines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Lucky mines",
      name: "Lucky mines",
      providerName: "WorldCasino",
    },
    Mines: {
      href: "/casino/io-mines",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Mines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Mines",
      name: "Mines",
      providerName: "WorldCasino",
    },
    PenaltyUnlimited: {
      href: "/casino/io-penalty-unlimited",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/PenaltyUnlimited.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Penalty Unlimited",
      name: "Penalty Unlimited",
      providerName: "WorldCasino",
    },

    SugarDaddy: {
      href: "/casino/io-sugar-daddy",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/SugarDaddy.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Sugar Daddy",
      name: "Sugar Daddy",
      providerName: "WorldCasino",
    },
    CricketRoad: {
      href: "/casino/io-cricket-road",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/CricketRoad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Cricket Road",
      name: "Cricket Road",
      providerName: "WorldCasino",
    },
    ChickenRoadIce: {
      href: "/casino/io-chicken-road-ice",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoadIce.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road Ice",
      name: "Chicken Road Ice",
      providerName: "WorldCasino",
    },
    Diver: {
      href: "/casino/io-diver",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Diver.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Diver",
      name: "Diver",
      providerName: "WorldCasino",
    },
    ForestArrow: {
      href: "/casino/io-forest-arrow",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ForestArrow.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Forest Arrow",
      name: "Forest Arrow",
      providerName: "WorldCasino",
    },
    JogoDoBicho: {
      href: "/casino/io-jogo-do-bicho",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/JogoDoBicho.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Jogo Do Bicho",
      name: "Jogo Do Bicho",
      providerName: "WorldCasino",
    },
    NewDouble: {
      href: "/casino/io-new-double",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/NewDouble.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "New Double",
      name: "New Double",
      providerName: "WorldCasino",
    },
    SweetKeno: {
      href: "/casino/io-sweet-keno",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/SweetKeno.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Sweet Keno",
      name: "Sweet Keno",
      providerName: "WorldCasino",
    },
    HamsterRun: {
      href: "/casino/io-hamster-run",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/HamsterRun.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Hamster Run",
      name: "Hamster Run",
      providerName: "WorldCasino",
    },
    HotMines: {
      href: "/casino/io-hot-mines",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/HotMines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Hot-mines",
      name: "Hot-mines",
      providerName: "WorldCasino",
    },
    Limbo: {
      href: "/casino/io-limbo",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Limbo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Limbo",
      name: "Limbo",
      providerName: "WorldCasino",
    },
    Triple: {
      href: "/casino/io-triple",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Triple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Triple",
      name: "Triple",
      providerName: "WorldCasino",
    },
    Twist: {
      href: "/casino/io-twist",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Twist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Twist",
      name: "Twist",
      providerName: "WorldCasino",
    },
    FishRoad: {
      href: "/casino/io-fish-road",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/FishRoad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Fish Road",
      name: "Fish Road",
      providerName: "WorldCasino",
    },
    NewHilo: {
      href: "/casino/io-new-hilo",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/NewHilo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "New Hilo",
      name: "New Hilo",
      providerName: "WorldCasino",
    },
    Plinko1000: {
      href: "/casino/io-plinko-1000",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Plinko1000.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Plinko 1000",
      name: "Plinko 1000",
      providerName: "WorldCasino",
    },
    PlinkoAZTEC: {
      href: "/casino/io-plinko-aztec",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/PlinkoAZTEC.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Plinko AZTEC",
      name: "Plinko AZTEC",
      providerName: "WorldCasino",
    },
    RoboDice: {
      href: "/casino/io-robo-dice",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/RoboDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Robo dice",
      name: "Robo dice",
      providerName: "WorldCasino",
    },
    SquidGamebler: {
      href: "/casino/io-squid-gamebler",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/SquidGamebler.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Squid Gamebler",
      name: "Squid Gamebler",
      providerName: "WorldCasino",
    },
    Stairs: {
      href: "/casino/io-stairs",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Stairs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Stairs",
      name: "Stairs",
      providerName: "WorldCasino",
    },
    Tower: {
      href: "/casino/io-tower",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Tower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Tower",
      name: "Tower",
      providerName: "WorldCasino",
    },
    JokerPoker: {
      href: "/casino/io-joker-poker",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/JokerPoker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Joker Poker",
      name: "Joker Poker",
      providerName: "WorldCasino",
    },
    RabbitRoad: {
      href: "/casino/io-rabbit-road",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/RabbitRoad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Rabbit Road",
      name: "Rabbit Road",
      providerName: "WorldCasino",
    },
    RockPaperScissors: {
      href: "/casino/io-rock-paper-scissors",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/RockPaperScissors.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "WorldCasino",
    },
    ChickenRoadRace: {
      href: "/casino/io-chicken-road-race",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/ChickenRoadRace.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Chicken Road Race",
      name: "Chicken Road Race",
      providerName: "WorldCasino",
    },
    FishBoom: {
      href: "/casino/io-fish-boom",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/FishBoom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Fish Boom",
      name: "Fish Boom",
      providerName: "WorldCasino",
    },
    PenguSport: {
      href: "/casino/io-pengu-sport",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/PenguSport.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Pengu Sport",
      name: "Pengu Sport",
      providerName: "WorldCasino",
    },
    Roulette: {
      href: "/casino/io-roulette",
      code: "",
      casino: "InOut",
      imgUrl: "/images/slots/new/inout/Roulette.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      alt: "Roulette",
      name: "Roulette",
      providerName: "WorldCasino",
    },
  },

  mac88Virtualtab: {
    LuckyTigerMines: {
      href: "/casino/aggapmac88gamingvirtual-lucky-tiger-mines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ltm.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Tiger Mines",
      providerName: "MAC88 Virtual",
    },
    LuckyTigerSpin: {
      href: "/casino/aggapmac88gamingvirtual-lucky-tiger-spin",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/lts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Tiger Spin",
      providerName: "MAC88 Virtual",
    },
    Snakes: {
      href: "/casino/aggapmac88gamingvirtual-snakes",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/snakes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snakes",
      providerName: "MAC88 Virtual",
    },
    "Chicken Road Cross 2": {
      href: "/casino/aggapmac88gamingvirtual-chicken-road-cross-2",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/chicken_road_cross2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chicken Road Cross 2",
      providerName: "MAC88 Virtuals",
    },
    "Rock Paper Scissors": {
      href: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/rps.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rock Paper Scissors",
      providerName: "MAC88 Virtual",
    },
    "Hi Lo": {
      href: "/casino/aggapmac88gamingvirtual-hi-lo",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/hilo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hi Lo",
      providerName: "MAC88 Virtual",
    },
    "X Roulette": {
      href: "/casino/aggapmac88gamingvirtual-x-roulette",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/roulette.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "X Roulette",
      providerName: "MAC88 Virtual",
    },
    Vortex: {
      href: "/casino/aggapmac88gamingvirtual-vortex",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/vortex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vortex",
      providerName: "MAC88 Virtuals",
    },
    Diamonds: {
      href: "/casino/aggapmac88gamingvirtual-diamonds",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/diamonds.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamonds",
      providerName: "MAC88 Virtual",
    },
    Mines: {
      href: "/casino/aggapmac88gamingvirtual-mines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/mines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mines",
      providerName: "MAC88 Virtuals",
    },
    Dice: {
      href: "/casino/aggapmac88gamingvirtual-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/dice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice",
      providerName: "MAC88 Virtual",
    },
    Limbo: {
      href: "/casino/aggapmac88gamingvirtual-limbo",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/limbo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Limbo",
      providerName: "MAC88 Virtual",
    },
    FireworkX: {
      href: "/casino/aggapmac88gamingvirtual-fireworkx",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/FireWorkX.jpg",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "FireworkX",
      providerName: "MAC88 Virtual",
    },
    LanternX: {
      href: "/casino/aggapmac88gamingvirtual-lanternx",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/lanternx.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "LanternX",
      providerName: "MAC88 Virtual",
    },
    Kancha: {
      href: "/casino/aggapmac88gamingvirtual-kancha",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/kancha.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Kancha",
      providerName: "MAC88 Virtual",
    },
    PlaneCrash: {
      href: "/casino/aggapmac88gamingvirtual-plane-crash",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/planecrash.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Plane Crash",
      providerName: "MAC88 Virtual",
    },
    Skyfall: {
      href: "/casino/aggapmac88gamingvirtual-sky-fall",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/skyfall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sky fall",
      providerName: "MAC88 Virtual",
    },
    ChickenRoadCross: {
      href: "/casino/aggapmac88gamingvirtual-chicken-road-cross",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/chickyroadcross.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chicken Road Cross",
      providerName: "MAC88 Virtuals",
    },
    ChickenRun: {
      href: "/casino/aggapmac88gamingvirtual-chicken-run",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/chickyrun.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chicken Run",
      providerName: "MAC88 Virtuals",
    },
    JetXT: {
      href: "/casino/aggapmac88gamingvirtual-jet-xt",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jetxt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jet XT",
      providerName: "MAC88 Virtual",
    },
    Kitex: {
      href: "/casino/aggapmac88gamingvirtual-kitex",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/kitex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Kitex",
      providerName: "MAC88 Virtual",
    },
    PushpaRani: {
      href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/pushpa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pushpa Rani",
      providerName: "MAC88 Virtual",
    },
    CrashX: {
      href: "/casino/aggapmac88gamingvirtual-crash-x",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/crashx.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crash X",
      providerName: "MAC88 Virtual",
    },
    AviatorX2: {
      href: "/casino/aggapmac88gamingvirtual-aviatorx2",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/aviatorx2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "AviatorX2",
      providerName: "MAC88 Virtual",
    },
    FortuneWheel: {
      href: "/casino/aggapmac88gamingvirtual-fortune-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/fortunewheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune Wheel",
      providerName: "MAC88 Virtual",
    },
    CoinFlip: {
      href: "/casino/aggapmac88gamingvirtual-coin-flip",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/flip.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Coin Flip",
      providerName: "MAC88 Virtual",
    },
    Trade88RNG: {
      href: "/casino/aggapmac88gamingvirtual-trade88-rng",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/trade88.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 RNG",
      providerName: "MAC88 Virtual",
    },
    Trade88NATURALGAS: {
      href: "/casino/aggapmac88gamingvirtual-trade88-natural-gas",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/GAS.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 NATURAL GAS",
      providerName: "MAC88 Virtual",
    },
    Trade88OIL: {
      href: "/casino/aggapmac88gamingvirtual-trade88-oil",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/OIL.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 OIL",
      providerName: "MAC88 Virtual",
    },
    Trade88SILVER: {
      href: "/casino/aggapmac88gamingvirtual-trade88-silver",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/SILVER.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 SILVER",
      providerName: "MAC88 Virtual",
    },
    Trade88GOLD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/GOLD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 GOLD",
      providerName: "MAC88 Virtual",
    },
    Trade88LTCUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-ltcusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/LTCUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 LTCUSD",
      providerName: "MAC88 Virtual",
    },
    Trade88BTCUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-btcusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/BTCUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 BTCUSD",
      providerName: "MAC88 Virtual",
    },
    Trade88BNBUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-bnbusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/BNBUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 BNBUSD",
      providerName: "MAC88 Virtuals",
    },
    Trade88ETHUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-ethusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ETHUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 ETHUSD",
      providerName: "MAC88 Virtual",
    },
    Trade88USDCAD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-usdcad",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/USDCAD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 USDCAD",
      providerName: "MAC88 Virtual",
    },
    Trade88GBPUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-gbpusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/GBPUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 GBPUSD",
      providerName: "MAC88 Virtual",
    },
    Trade88USDJPY: {
      href: "/casino/aggapmac88gamingvirtual-trade88-usdjpy",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/USDJPY.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 USDJPY",
      providerName: "MAC88 Virtuals",
    },
    Trade88EURUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-eurusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/EURUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 EURUSD",
      providerName: "MAC88 Virtual",
    },
    CricketBattle: {
      href: "/casino/aggapmac88gamingvirtual-cricket-battle",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/cricketbattle.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cricket Battle",
      providerName: "MAC88 Virtual",
    },
    VRLightningRoulettes: {
      href: "/casino/aggapmac88gamingvirtual-vr-lightning-roulette",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/VLRT.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "VR Lightning Roulette",
      providerName: "MAC88 Virtual",
    },
    Trade88RNG2: {
      href: "/casino/aggapmac88gamingvirtual-trade88-rng2",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/RNG2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 RNG2",
      providerName: "MAC88 Virtual",
    },
    DealOrNoDeal: {
      href: "/casino/aggapmac88gamingvirtual-deal-or-no-deal",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/dnd.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Deal Or No Deal",
      providerName: "MAC88 Virtual",
    },
    TheVoice: {
      href: "/casino/aggapmac88gamingvirtual-the-voice",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/voice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Voice",
      providerName: "MAC88 Virtual",
    },
    Trade88ETHUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-ethusd-u2944",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ETHUSD_1.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 ETHUSD",
      providerName: "MAC88 Virtual",
    },
    Trade88SOLUSD: {
      href: "/casino/aggapmac88gamingvirtual-trade88-solusd",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/SOLUSD.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Trade88 SOLUSD",
      providerName: "MAC88 Virtual",
    },
    CRASHMAN: {
      href: "/casino/aggapmac88gamingvirtual-crash-man",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/crashman.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "CRASH MAN",
      providerName: "MAC88 Virtual",
    },
    Packs: {
      href: "/casino/aggapmac88gamingvirtual-packs",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/packs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Packs",
      providerName: "MAC88 Virtual",
    },
    DragonTower: {
      href: "/casino/aggapmac88gamingvirtual-dragon-tower",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/dragontower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon Tower",
      providerName: "MAC88 Virtual",
    },
    Pump: {
      href: "/casino/aggapmac88gamingvirtual-pump",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/pump.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pump",
      providerName: "MAC88 Virtual",
    },
    JalwaColorGame10: {
      href: "/casino/aggapmac88gamingvirtual-jalwa-color-game-10",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jalwacolorgame.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jalwa Color Game 10",
      providerName: "MAC88 Virtual",
    },
    JalwaColorGame5: {
      href: "/casino/aggapmac88gamingvirtual-jalwa-color-game-5",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jalwacolorgame.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jalwa Color Game 5",
      providerName: "MAC88 Virtual",
    },
    JalwaColorGame3: {
      href: "/casino/aggapmac88gamingvirtual-jalwa-color-game-3",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jalwacolorgame.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jalwa Color Game 3",
      providerName: "MAC88 Virtual",
    },
    JalwaColorGame: {
      href: "/casino/aggapmac88gamingvirtual-jalwa-color-game",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jalwacolorgame.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: " Jalwa Color Game",
      providerName: "MAC88 Virtual",
    },
    NaughtyButton: {
      href: "/casino/aggapmac88gamingvirtual-naughty-button",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/naughtybutton.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Naughty Button",
      providerName: "MAC88 Virtual",
    },
    RaceTrack: {
      href: "/casino/aggapmac88gamingvirtual-race-track",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/racetrack.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Race Track",
      providerName: "MAC88 Virtual",
    },
    Pick33min: {
      href: "/casino/aggapmac88gamingvirtual-pick3-3min",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/pick3.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pick3 3min",
      providerName: "MAC88 Virtual",
    },
    Pick31min: {
      href: "/casino/aggapmac88gamingvirtual-pick3-1min",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/pick3.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pick3 1min",
      providerName: "MAC88 Virtual",
    },
    StockMatka: {
      href: "/casino/aggapmac88gamingvirtual-stock-matka",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/stockmatka.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Stock Matka",
      providerName: "MAC88 Virtual",
    },
    JhandiMunda: {
      href: "/casino/aggapmac88gamingvirtual-jhandi-munda",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/jhandimunda.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jhandi Munda",
      providerName: "MAC88 Virtual",
    },
    "5Boys": {
      href: "/casino/aggapmac88gamingvirtual-5-boys",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/5Boys.jpg",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Boys",
      providerName: "MAC88 Virtual",
    },
    "Ball by Ball VR": {
      href: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/bbb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ball by Ball VR",
      providerName: "MAC88 Virtual",
    },
    "Lucky 15": {
      href: "/casino/aggapmac88gamingvirtual-lucky-15",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/lucky15.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky 15",
      providerName: "MAC88 Virtual",
    },
    "Bolly Kiss": {
      href: "/casino/aggapmac88gamingvirtual-bolly-kiss",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/bk1.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bolly Kiss",
      providerName: "MAC88 Virtual",
    },
    "Lucky 5": {
      href: "/casino/aggapmac88gamingvirtual-lucky-5",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/vlucky5.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky 5",
      providerName: "MAC88 Virtual",
    },
    Plinko: {
      href: "/casino/aggapmac88gamingvirtual-plinko",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/plinko.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Plinko",
      providerName: "MAC88 Virtual",
    },
    AK47VR: {
      href: "/casino/aggapmac88gamingvirtual-ak47-vr",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ak47_vr.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "AK47 VR",
      providerName: "MAC88 Virtual",
    },
    "Kaun Banega Crorepati VR": {
      href: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/kbc_vr.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Kaun Banega Crorepati VR",
      providerName: "MAC88 Virtual",
    },
    "Center Card VR": {
      href: "/casino/aggapmac88gamingvirtual-center-card-vr",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/vr_cc.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Center Card VR",
      providerName: "MAC88 Virtual",
    },
    "Hi Lo VR": {
      href: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/vr_hc.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hi Lo VR",
      providerName: "MAC88 Virtual",
    },
    "K3 Lottery 10": {
      href: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/3k_lotre.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "K3 Lottery 10",
      providerName: "MAC88 Virtual",
    },
    "K3 Lottery 5": {
      href: "/casino/aggapmac88gamingvirtual-k3-lottery-5",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/3k_lotre.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "K3 Lottery 5",
      providerName: "MAC88 Virtual",
    },
    "K3 Lottery 3": {
      href: "/casino/aggapmac88gamingvirtual-k3-lottery-3",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ltm.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "K3 Lottery 3",
      providerName: "MAC88 Virtual",
    },
    LuckyTigerMines: {
      href: "/casino/aggapmac88gamingvirtual-lucky-tiger-mines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ltm.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Tiger Mines",
      providerName: "MAC88 Virtual",
    },
    LuckyTigerMines: {
      href: "/casino/aggapmac88gamingvirtual-lucky-tiger-mines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ltm.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Tiger Mines",
      providerName: "MAC88 Virtual",
    },
    LuckyTigerMines: {
      href: "/casino/aggapmac88gamingvirtual-lucky-tiger-mines",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/mac88virtual/ltm.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Tiger Mines",
      providerName: "MAC88 Virtual",
    },
  },

  PopokGaming: {
    CrashoSaurus: {
      href: "/casino/aggappopok-crashosaurus",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/CrashoSaurus.webp",
      alt: "CrashoSaurus",
      name: "CrashoSaurus",
    },
    CrazyPokiBoo: {
      href: "/casino/aggappopok-crazy-poki-boo-u6978",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/CrazyPokiBoo.webp",
      alt: "Crazy Poki Boo",
      name: "Crazy Poki Boo",
    },
    Dice: {
      href: "/casino/aggappopok-dice",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    FastFruits: {
      href: "/casino/aggappopok-fast-fruits-u3499",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/fastfruits.webp",
      alt: "Fast Fruits",
      name: "Fast Fruits",
    },
    FastMaster: {
      href: "/casino/aggappopok-fast-master-u5837",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/fastmaster.webp",
      alt: "Fast Master",
      name: "Fast Master",
    },
    FieryFruitsMoreSpins: {
      href: "/casino/aggappopok-fiery-fruits-more-spins",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/fietyfruitsmorespins.webp",
      alt: "Fiery Fruits More Spins",
      name: "Fiery Fruits More Spins",
    },
    FirstBalloon: {
      href: "/casino/aggappopok-first-balloon",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/firstballlon.webp",
      alt: "First Balloon",
      name: "First Balloon",
    },
    FortunePanda: {
      href: "/casino/aggappopok-fortune-panda",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/fortunepanda.webp",
      alt: "Fortune Panda",
      name: "Fortune Panda",
    },
    HalloweenCrash: {
      href: "/casino/aggappopok-halloween-crash-u1317",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/halloweencrash.webp",
      alt: "Halloween Crash",
      name: "Halloween Crash",
    },
    HoHoHo: {
      href: "/casino/aggappopok-ho-ho-ho-u1958",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/hohoho.webp",
      alt: "Ho Ho Ho",
      name: "Ho Ho Ho",
    },
    HotAngels: {
      href: "/casino/aggappopok-hot-angels-u6917",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/hotangels.webp",
      alt: "Hot Angels",
      name: "Hot Angels",
    },
    IncredibleGenie: {
      href: "/casino/aggappopok-incredible-genie-u1833",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/incrediblegenie.webp",
      alt: "Incredible Genie",
      name: "Incredible Genie",
    },
    InstantKeno: {
      href: "/casino/aggappopok-instant-keno",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/instantkeno.webp",
      alt: "Instant Keno",
      name: "Instant Keno",
    },
    JacksorBetter: {
      href: "/casino/aggappopok-jacks-or-better",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/jacksorbetter.webp",
      alt: "Jacks or Better",
      name: "Jacks or Better",
    },
    KingCraftMenomin: {
      href: "/casino/aggappopok-king-craft-menomin",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/kingcraftmenomin.webp",
      alt: "King Craft: Menomin",
      name: "King Craft: Menomin",
    },
    LuckyClover: {
      href: "/casino/aaggappopok-lucky-clover",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/luckyclover.webp",
      alt: "Lucky Clover",
      name: "Lucky Clover",
    },
    LuckySpin: {
      href: "/casino/aggappopok-lucky-spin",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/luckyspin.webp",
      alt: "Lucky Spin",
      name: "Lucky Spin",
    },
    MagicTime: {
      href: "/casino/aggappopok-magic-time-u4328",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/magictime.webp",
      alt: "Magic Time",
      name: "Magic Time",
    },
    MegaDiamonds: {
      href: "/casino/aggappopok-mega-diamonds",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/megadiamonds.webp",
      alt: "Mega Diamonds",
      name: "Mega Diamonds",
    },
    MilkyFarm: {
      href: "/casino/aggappopok-milky-farm-u4339",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/milkyfarm.webp",
      alt: "Milky Farm",
      name: "Milky Farm",
    },
    MilkyFarmBuyFeature: {
      href: "/casino/aggappopok-milky-farm-buy-feature",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/milkyfarmbuyfeatures.webp",
      alt: "Milky Farm Buy Feature",
      name: "Milky Farm Buy Feature",
    },
    Mines: {
      href: "/casino/aggappopok-mines",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    MrFirstLuckyWheel: {
      href: "/casino/aggappopok-mr-first-lucky-wheel",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/mrfirstluckywheel.webp",
      alt: "Mr. First: Lucky Wheel",
      name: "Mr. First: Lucky Wheel",
    },
    NinjaFruitCubes: {
      href: "/casino/aggappopok-ninja-fruit-cubes",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/ninjafruitcubes.webp",
      alt: "Ninja Fruit Cubes",
      name: "Ninja Fruit Cubes",
    },
    PirateFortune: {
      href: "/casino/aggappopok-pirate-fortune",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/piratefortune.webp",
      alt: "Pirate Fortune",
      name: "Pirate Fortune",
    },
    RedHotLine: {
      href: "/casino/aggappopok-red-hot-line",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/redhotline.webp",
      alt: "Red Hot Line",
      name: "Red Hot Line",
    },
    RedHotLine2: {
      href: "/casino/aggappopok-red-hot-line-2",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/redhotLine2.webp",
      alt: "Red Hot Line 2",
      name: "Red Hot Line 2",
    },
    RicoGorila: {
      href: "/casino/aggappopok-rico-gorila",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/rice.webp",
      alt: "Rico Gorila",
      name: "Rico Gorila",
    },
    Ronin: {
      href: "/casino/aggappopok-ronin-u6260",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/ronin.webp",
      alt: "Ronin",
      name: "Ronin",
    },
    RoyalFlash: {
      href: "/casino/aggappopok-royal-flash",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/royalflash.webp",
      alt: "Royal Flash",
      name: "Royal Flash",
    },
    Spinosaurus: {
      href: "/casino/aggappopok-spinosaurus",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/spinosaurus.webp",
      alt: "Spinosaurus",
      name: "Spinosaurus",
    },
    ThePowerofKitsune: {
      href: "/casino/aggappopok-the-power-of-kitsune-u6283",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/thepowerofkitsune.webp",
      alt: "The Power of Kitsune",
      name: "The Power of Kitsune",
    },
    TikiQuest: {
      href: "/casino/aggappopok-tiki-quest",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/tikiqurst.webp",
      alt: "Tiki Quest",
      name: "Tiki Quest",
    },
    TimeTravelersHacivatandKaragoz: {
      href: "/casino/aggappopok-time-travelers-hacivat-and-karagoz",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/timetravelershacivatandkaragoz.webp",
      alt: "Time Travelers: Hacivat and Karagoz",
      name: "Time Travelers: Hacivat and Karagoz",
    },
    WhiteMustang: {
      href: "/casino/aggappopok-white-mustang",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/whitemustang.webp",
      alt: "White Mustang",
      name: "White Mustang",
    },
    WildQueen: {
      href: "/casino/aggappopok-wild-queen-u1099",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/wildqueen.webp",
      alt: "Wild Queen",
      name: "Wild Queen",
    },
    WildShamrock: {
      href: "/casino/aggappopok-wild-shamrock",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/wildshamrock.webp",
      alt: "Wild Shamrock",
      name: "Wild Shamrock",
    },
    Wukong: {
      href: "/casino/aggappopok-wukong-u6790",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/wukong.webp",
      alt: "Wukong",
      name: "Wukong",
    },
    FlamingPhoenix: {
      href: "/casino/aggappopok-flaming-phoenix-u1604",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/flamingphoenix.webp",
      alt: "Flaming Phoenix",
      name: "Flaming Phoenix",
    },
    FruitBall: {
      href: "/casino/aggappopok-fruit-ball-u7010",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/fruitball.webp",
      alt: "Fruit Ball",
      name: "Fruit Ball",
    },
    PokiWild: {
      href: "/casino/aggappopok-poki-wild-u2866",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/pokiwild.webp",
      alt: "Poki Wild",
      name: "Poki Wild",
    },
    LosToros: {
      href: "/casino/aggappopok-los-toros-u8589",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/lostoros.webp",
      alt: "Los Toros",
      name: "Los Toros",
    },
    ElectricCrash: {
      href: "/casino/aggappopok-electric-crash",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/electriccash.webp",
      alt: "Electric Crash",
      name: "Electric Crash",
    },
    TempleofHeroes: {
      href: "/casino/aggappopok-temple-of-heroes-u2481",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/templeofheros.webp",
      alt: "Temple of Heroes",
      name: "Temple of Heroes",
    },
    HiLo: {
      href: "/casino/aggappopok-hi-lo",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/hilo.webp",
      alt: "Hi Lo",
      name: "Hi Lo",
    },
    RichyPanda: {
      href: "/casino/aggappopok-richy-panda-u1488",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Richy Panda",
      name: "Richy Panda",
    },
    DiamondQuest: {
      href: "/casino/aggappopok-diamond-quest",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Diamond Quest",
      name: "Diamond Quest",
    },
    FlamingFruit: {
      href: "/casino/aggappopok-flaming-fruit-u1148",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Flaming Fruit",
      name: "Flaming Fruit",
    },
    GogoBanana: {
      href: "/casino/aggappopok-gogo-banana",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Gogo Banana",
      name: "Gogo Banana",
    },
    MagicIdol: {
      href: "/casino/aggappopok-magic-idol",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Magic Idol",
      name: "Magic Idol",
    },
    Plinko: {
      href: "/casino/aggappopok-plinko",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Plinko",
      name: "Plinko",
    },
    LuckySmile: {
      href: "/casino/aggappopok-lucky-smile-u6471",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Lucky Smile",
      name: "Lucky Smile",
    },
    VikingsMystery: {
      href: "/casino/aggappopok-vikings-mystery-u8444",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Vikings Mystery",
      name: "Vikings Mystery",
    },
    YummyTrickorTreat: {
      href: "/casino/aggappopok-yummy-trick-or-treat-u7769",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Yummy Trick or Treat",
      name: "Yummy Trick or Treat",
    },
    HugaChaga: {
      href: "/casino/aggappopok-huga-chaga-u9630",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Huga Chaga",
      name: "Huga Chaga",
    },
    UltraWheel: {
      href: "/casino/aggappopok-ultra-wheel-u3684",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Ultra Wheel",
      name: "Ultra Wheel",
    },
    Yummy: {
      href: "/casino/aggappopok-yummy-u2342",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Yummy",
      name: "Yummy",
    },
    Baccarat: {
      href: "/casino/aggappopok-baccarat",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    CrazyPoki: {
      href: "/casino/aggappopok-crazy-poki-u1048",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Crazy Poki",
      name: "Crazy Poki",
    },
    FourtyHotBarExtra: {
      href: "/casino/aggappopok-40-hot-bar-extra-u8255",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "40 Hot Bar Extra",
      name: "40 Hot Bar Extra",
    },
    FourtyHotBar: {
      href: "/casino/aggappopok-40-hot-bar-u3470",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "40 Hot Bar",
      name: "40 Hot Bar",
    },
    GoldofEgypt: {
      href: "/casino/aggappopok-gold-of-egypt-u7353",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Gold of Egypt",
      name: "Gold of Egypt",
    },
    TwentyHotBar: {
      href: "/casino/aggappopok-20-hot-bar-u4600",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "20 Hot Bar",
      name: "20 Hot Bar",
    },
    HappyValentinesDay: {
      href: "/casino/aggappopok-happy-valentines-day-u8335",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Happy Valentine's Day",
      name: "Happy Valentine's Day",
    },
    HotMuchacho: {
      href: "/casino/aggappopok-hot-muchacho-u9853",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Hot Muchacho",
      name: "Hot Muchacho",
    },
    HappyEaster: {
      href: "/casino/aggappopok-happy-easter-u2661",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Happy Easter",
      name: "Happy Easter",
    },
    MegaJoker: {
      href: "/casino/aggappopok-mega-joker-u3160",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Mega Joker",
      name: "Mega Joker",
    },
    HundredLuckyBell: {
      href: "/casino/aggappopok-100-lucky-bell-u6466",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "100 Lucky Bell",
      name: "100 Lucky Bell",
    },

    LuckyJungle1024Ways: {
      href: "/casino/aggappopok-lucky-jungle-1024-ways-u7545",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Lucky Jungle 1024 Ways",
      name: "Lucky Jungle 1024 Ways",
    },
    HotBar: {
      href: "/casino/aggappopok-hot-bar-u6680",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Hot Bar",
      name: "Hot Bar",
    },
    NovelofAlexander: {
      href: "/casino/aggappopok-novel-of-alexander-u4215",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Novel of Alexander",
      name: "Novel of Alexander",
    },
    OctopusLife: {
      href: "/casino/aggappopok-octopus-life-u9928",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Octopus Life",
      name: "Octopus Life",
    },
    LuckyPatricksDay: {
      href: "/casino/aggappopok-lucky-patricks-day-u4093",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Lucky Patrick's Day",
      name: "Lucky Patrick's Day",
    },
    EraofDragons: {
      href: "/casino/aggappopok-era-of-dragons-u1942",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Era of Dragons",
      name: "Era of Dragons",
    },
    MagictreasuresofEgypt: {
      href: "/casino/aggappopok-magic-treasures-of-egypt-u9619",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Magic treasures of Egypt",
      name: "Magic treasures of Egypt",
    },
    LosApaches: {
      href: "/casino/aggappopok-los-apaches-u7596",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Los Apaches",
      name: "Los Apaches",
    },
    SultansTale: {
      href: "/casino/aggappopok-sultans-tale-u7236",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Sultan’s Tale",
      name: "Sultan’s Tale",
    },
    FoutyLuckyBell: {
      href: "/casino/aggappopok-40-lucky-bell-u7557",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "40 Lucky Bell",
      name: "40 Lucky Bell",
    },
    TwentyLuckyBell: {
      href: "/casino/aggappopok-20-lucky-bell-u2339",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "20 Lucky Bell",
      name: "20 Lucky Bell",
    },
    UltraHot: {
      href: "/casino/aggappopok-ultra-hot-u4476",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Ultra Hot",
      name: "Ultra Hot",
    },
    DiamondFlash: {
      href: "/casino/aggappopok-diamond-flash-u4593",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Diamond Flash",
      name: "Diamond Flash",
    },
    LuckyJungle: {
      href: "/casino/aggappopok-lucky-jungle-u7001",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Lucky Jungle",
      name: "Lucky Jungle",
    },
    LostTreasure: {
      href: "/casino/aggappopok-lost-treasure-u8623",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Lost Treasure",
      name: "Lost Treasure",
    },
    FrozenFruits: {
      href: "/casino/aggappopok-frozen-fruits-u9271",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Frozen Fruits",
      name: "Frozen Fruits",
    },
    SumoBaby: {
      href: "/casino/aggappopok-sumo-baby",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Sumo Baby",
      name: "Sumo Baby",
    },
    DiamondPhantom: {
      href: "/casino/aggappopok-diamond-phantom-u8253",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Diamond Phantom",
      name: "Diamond Phantom",
    },
    XmasCrash: {
      href: "/casino/aggappopok-xmas-crash",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Xmas Crash",
      name: "Xmas Crash",
    },
    Fiesta: {
      href: "/casino/aggappopok-fiesta",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Fiesta",
      name: "Fiesta",
    },
    BookofSherlock: {
      href: "/casino/aggappopok-book-of-sherlock",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Book of Sherlock",
      name: "Book of Sherlock",
    },
    HezarfenCrash: {
      href: "/casino/aggappopok-hezarfen-crash",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Hezarfen Crash",
      name: "Hezarfen Crash",
    },
    PapaiNoeldaFortuna: {
      href: "/casino/aggappopok-papai-noel-da-fortuna",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Papai Noel da Fortuna",
      name: "Papai Noel da Fortuna",
    },
    CrashPoki: {
      href: "/casino/aggappopok-crash-poki",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Crash Poki",
      name: "Crash Poki",
    },
    YODragon: {
      href: "/casino/aggappopok-yo-dragon",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "YO Dragon",
      name: "YO Dragon",
    },
    SevenSevenSevenTripleSevens: {
      href: "/casino/aggappopok-777-triple-sevens",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "777 Triple Sevens",
      name: "777 Triple Sevens",
    },
    Avi: {
      href: "/casino/aggappopok-avi",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Avi",
      name: "Avi",
    },
    RoyalFlashBuyBonus: {
      href: "/casino/aggappopok-royal-flash-buy-bonus",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Royal Flash Buy Bonus",
      name: "Royal Flash Buy Bonus",
    },
    DiamondFlashBuyBonus: {
      href: "/casino/aggappopok-diamond-flash-buy-bonus",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Diamond Flash Buy Bonus",
      name: "Diamond Flash Buy Bonus",
    },
    EyeontheMoney: {
      href: "/casino/aggappopok-eye-on-the-money",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Eye on the Money",
      name: "Eye on the Money",
    },
    GoddessesofZeus: {
      href: "/casino/aggappopok-goddesses-of-zeus-u2565",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Goddesses of Zeus",
      name: "Goddesses of Zeus",
    },
    BlazingHot: {
      href: "/casino/aggappopok-blazing-hot",
      code: "",
      casino: "Popok",
      provider: "ALT_GAMING_GAP",
      providerName: "ALT_GAMING_GAP",
      category: "Video Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino/popok/SpeedBaccaratD08.webp",
      alt: "Blazing Hot",
      name: "Blazing Hot",
    },
  },

  homepageSlots: {
    ReelHeist: {
      href: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      href: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      href: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/snowwildandthe7features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      href: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/SylvanSpirit.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      href: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/thegreatesttrainrobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      href: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/TheWildhatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      href: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      href: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/TikkiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      href: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/vaultcracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      href: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/totemlightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      href: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/wellofwishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      href: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/vaultofanubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      href: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      href: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      href: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/yucatansmystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      href: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      href: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
    GodOfWealth: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    asgardianstones: {
      href: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/asgardianstones.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      href: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/secretsofatlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      href: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/SteamTower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      href: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/DivineFortunemegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      href: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/Fruitshopmegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/GorillaKingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      href: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/Alohachristmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      href: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/Alohachristmaspays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      href: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/WildWildWestthegreattrainheist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/TwinSpinMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      href: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/TurnYourFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      href: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "/images/slots/SlotsNew/pyramidquestforimmortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
  },
};
